/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * Lead Engine — local business opportunity detector
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  ActivePromptCouncilSessionResponse,
  ActiveSurgeTriggersResponse,
  AnswerPromptCouncilClarificationBody,
  ApproveCockpitEstimateBody,
  CallFunnelStats,
  CancelLeadBody,
  ClearPromptCouncilCacheResponse,
  ClonePromptCouncilSessionBody,
  CockpitAnalyzeBody,
  CockpitBlock,
  CockpitBlockBody,
  CockpitCatalogBlock,
  CockpitCatalogTool,
  CockpitEstimate,
  CockpitEstimateDetail,
  CockpitHandoff,
  CockpitSampleProject,
  CompetitorList,
  CreateLeadBody,
  CreateLeadCallBody,
  CreateLeadCallResponse,
  CreateObjectionRebuttalBody,
  CreatePromptCouncilFilterPresetBody,
  CreatePromptCouncilSessionBody,
  CreateSearchBody,
  CreateWhatsappTemplate201,
  CreateWhatsappTemplateBody,
  DeleteObjectionRebuttal200,
  DeletePromptCouncilFilterPreset200,
  DeleteWhatsappSettings200,
  DeleteWhatsappTemplate200,
  DemoMessagingConfig,
  DemoViewNotificationsConfig,
  DiscoveryDraft,
  DiscoveryTranscription,
  DraftLeadDiscoveryBody,
  DraftLeadFollowupBody,
  FollowupMessagingConfig,
  GenerateLeadDemoBody,
  GenerateLookalikes200,
  GenerateObjectionVariantBody,
  GetCallFunnelParams,
  GetLatestLookalikeBatch200,
  GetLeadCompetitorsParams,
  GetLeadStatsParams,
  GetLeadWhatsappHistory200,
  GetLookalikeBatchHistory200,
  GetRecentCallsParams,
  HealthStatus,
  ImportLeadsBody,
  ImportResult,
  Lead,
  LeadCall,
  LeadCallList,
  LeadFacets,
  LeadFollowupDraft,
  LeadList,
  LeadMapResponse,
  LeadStats,
  ListCockpitEstimatesParams,
  ListLeadCallsParams,
  ListLeadMapPinsParams,
  ListLeadsParams,
  ListNotificationsParams,
  ListPromptCouncilSessionsParams,
  ListSimilarCockpitEstimatesParams,
  ListWhatsappTemplates200,
  LookalikeAutoConfig,
  MarkLeadCallFollowupBody,
  MarkNotificationsReadBody,
  MarkNotificationsReadResponse,
  NotificationList,
  ObjectionRebuttal,
  ObjectionRebuttalList,
  ObjectionVariantResponse,
  PromptCouncilAgent,
  PromptCouncilAgentList,
  PromptCouncilAgentVersionList,
  PromptCouncilFilterPreset,
  PromptCouncilFilterPresetList,
  PromptCouncilSession,
  PromptCouncilSessionList,
  RecentCallList,
  RerunPromptCouncilStepBody,
  ResolvePromptCouncilCheckpointBody,
  RunNextPromptCouncilStepResponse,
  SaveCityBody,
  SaveDemoMessagingBody,
  SaveDemoViewNotificationsBody,
  SaveFollowupMessagingBody,
  SaveLeadForLaterBody,
  SaveLookalikeAutoConfig200,
  SaveLookalikeAutoConfigBody,
  SaveNicheBody,
  SaveSurgeTriggersConfigBody,
  SaveWhatsappConfigBody,
  SaveWhatsappSettings200,
  SavedCity,
  SavedNiche,
  Search,
  SearchResult,
  SendLeadWhatsapp200,
  SendLeadWhatsappBody,
  StartLeadProjectResponse,
  SuggestCityBody,
  SuggestCityResponse,
  SuggestIndustryBody,
  SuggestIndustryResponse,
  SurgeCronUserResult,
  SurgeTriggersConfigResponse,
  TestPromptCouncilAgentBody,
  TestPromptCouncilAgentResponse,
  TestWhatsappSettings200,
  TranscribeLeadDiscoveryBody,
  UpdateCockpitEstimateBody,
  UpdateLeadBody,
  UpdateLeadProjectBody,
  UpdateObjectionRebuttalBody,
  UpdatePromptCouncilAgentBody,
  UpdateWhatsappTemplate200,
  UpdateWhatsappTemplateBody,
  WhatsappConfig,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Returns server health status
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List recent discovery searches
 */
export const getListSearchesUrl = () => {
  return `/api/searches`;
};

export const listSearches = async (
  options?: RequestInit,
): Promise<Search[]> => {
  return customFetch<Search[]>(getListSearchesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListSearchesQueryKey = () => {
  return [`/api/searches`] as const;
};

export const getListSearchesQueryOptions = <
  TData = Awaited<ReturnType<typeof listSearches>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSearches>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSearchesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSearches>>> = ({
    signal,
  }) => listSearches({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSearches>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSearchesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSearches>>
>;
export type ListSearchesQueryError = ErrorType<unknown>;

/**
 * @summary List recent discovery searches
 */

export function useListSearches<
  TData = Awaited<ReturnType<typeof listSearches>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSearches>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSearchesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Runs a Google Maps search and stores newly discovered local businesses as leads.
 * @summary Discover new leads via Google Maps (SerpAPI)
 */
export const getCreateSearchUrl = () => {
  return `/api/searches`;
};

export const createSearch = async (
  createSearchBody: CreateSearchBody,
  options?: RequestInit,
): Promise<SearchResult> => {
  return customFetch<SearchResult>(getCreateSearchUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createSearchBody),
  });
};

export const getCreateSearchMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSearch>>,
    TError,
    { data: BodyType<CreateSearchBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSearch>>,
  TError,
  { data: BodyType<CreateSearchBody> },
  TContext
> => {
  const mutationKey = ["createSearch"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSearch>>,
    { data: BodyType<CreateSearchBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createSearch(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSearchMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSearch>>
>;
export type CreateSearchMutationBody = BodyType<CreateSearchBody>;
export type CreateSearchMutationError = ErrorType<unknown>;

/**
 * @summary Discover new leads via Google Maps (SerpAPI)
 */
export const useCreateSearch = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSearch>>,
    TError,
    { data: BodyType<CreateSearchBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSearch>>,
  TError,
  { data: BodyType<CreateSearchBody> },
  TContext
> => {
  return useMutation(getCreateSearchMutationOptions(options));
};

/**
 * Returns one context-aware city (and state) suggestion worth prospecting —
biased toward underserved mid-size US metros where the supplied
`business_type` is likely fragmented. When `business_type` is omitted
the model picks a generally underserved metro. Rate-limited the same way
as suggest-industry.

 * @summary AI-suggest a mid-size US city to prospect for the current business type
 */
export const getSuggestCityUrl = () => {
  return `/api/searches/suggest-city`;
};

export const suggestCity = async (
  suggestCityBody: SuggestCityBody,
  options?: RequestInit,
): Promise<SuggestCityResponse> => {
  return customFetch<SuggestCityResponse>(getSuggestCityUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(suggestCityBody),
  });
};

export const getSuggestCityMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof suggestCity>>,
    TError,
    { data: BodyType<SuggestCityBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof suggestCity>>,
  TError,
  { data: BodyType<SuggestCityBody> },
  TContext
> => {
  const mutationKey = ["suggestCity"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof suggestCity>>,
    { data: BodyType<SuggestCityBody> }
  > = (props) => {
    const { data } = props ?? {};

    return suggestCity(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SuggestCityMutationResult = NonNullable<
  Awaited<ReturnType<typeof suggestCity>>
>;
export type SuggestCityMutationBody = BodyType<SuggestCityBody>;
export type SuggestCityMutationError = ErrorType<void>;

/**
 * @summary AI-suggest a mid-size US city to prospect for the current business type
 */
export const useSuggestCity = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof suggestCity>>,
    TError,
    { data: BodyType<SuggestCityBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof suggestCity>>,
  TError,
  { data: BodyType<SuggestCityBody> },
  TContext
> => {
  return useMutation(getSuggestCityMutationOptions(options));
};

/**
 * Returns one fresh, narrow service-business niche worth
prospecting on the Discover Leads card — biased toward
fragmented mom-and-pop trades that would clearly benefit
from a basic website, simple CRM, or lightweight SaaS, and
away from crowded categories like "Restaurants" or
"Plumbers". The optional `recent` array (the last few niches
the rep has already seen this session) is forwarded into the
prompt so repeat clicks return new niches instead of
cycling the same handful.

 * @summary AI-suggest a single under-the-radar industry niche to prospect
 */
export const getSuggestIndustryUrl = () => {
  return `/api/searches/suggest-industry`;
};

export const suggestIndustry = async (
  suggestIndustryBody: SuggestIndustryBody,
  options?: RequestInit,
): Promise<SuggestIndustryResponse> => {
  return customFetch<SuggestIndustryResponse>(getSuggestIndustryUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(suggestIndustryBody),
  });
};

export const getSuggestIndustryMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof suggestIndustry>>,
    TError,
    { data: BodyType<SuggestIndustryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof suggestIndustry>>,
  TError,
  { data: BodyType<SuggestIndustryBody> },
  TContext
> => {
  const mutationKey = ["suggestIndustry"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof suggestIndustry>>,
    { data: BodyType<SuggestIndustryBody> }
  > = (props) => {
    const { data } = props ?? {};

    return suggestIndustry(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SuggestIndustryMutationResult = NonNullable<
  Awaited<ReturnType<typeof suggestIndustry>>
>;
export type SuggestIndustryMutationBody = BodyType<SuggestIndustryBody>;
export type SuggestIndustryMutationError = ErrorType<void>;

/**
 * @summary AI-suggest a single under-the-radar industry niche to prospect
 */
export const useSuggestIndustry = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof suggestIndustry>>,
    TError,
    { data: BodyType<SuggestIndustryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof suggestIndustry>>,
  TError,
  { data: BodyType<SuggestIndustryBody> },
  TContext
> => {
  return useMutation(getSuggestIndustryMutationOptions(options));
};

/**
 * @summary List the operator's saved industry niches
 */
export const getListSavedNichesUrl = () => {
  return `/api/searches/saved-niches`;
};

export const listSavedNiches = async (
  options?: RequestInit,
): Promise<SavedNiche[]> => {
  return customFetch<SavedNiche[]>(getListSavedNichesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListSavedNichesQueryKey = () => {
  return [`/api/searches/saved-niches`] as const;
};

export const getListSavedNichesQueryOptions = <
  TData = Awaited<ReturnType<typeof listSavedNiches>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSavedNiches>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSavedNichesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSavedNiches>>> = ({
    signal,
  }) => listSavedNiches({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSavedNiches>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSavedNichesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSavedNiches>>
>;
export type ListSavedNichesQueryError = ErrorType<unknown>;

/**
 * @summary List the operator's saved industry niches
 */

export function useListSavedNiches<
  TData = Awaited<ReturnType<typeof listSavedNiches>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSavedNiches>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSavedNichesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Save an industry niche to the operator's list
 */
export const getSaveNicheUrl = () => {
  return `/api/searches/saved-niches`;
};

export const saveNiche = async (
  saveNicheBody: SaveNicheBody,
  options?: RequestInit,
): Promise<SavedNiche> => {
  return customFetch<SavedNiche>(getSaveNicheUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(saveNicheBody),
  });
};

export const getSaveNicheMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveNiche>>,
    TError,
    { data: BodyType<SaveNicheBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveNiche>>,
  TError,
  { data: BodyType<SaveNicheBody> },
  TContext
> => {
  const mutationKey = ["saveNiche"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveNiche>>,
    { data: BodyType<SaveNicheBody> }
  > = (props) => {
    const { data } = props ?? {};

    return saveNiche(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveNicheMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveNiche>>
>;
export type SaveNicheMutationBody = BodyType<SaveNicheBody>;
export type SaveNicheMutationError = ErrorType<unknown>;

/**
 * @summary Save an industry niche to the operator's list
 */
export const useSaveNiche = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveNiche>>,
    TError,
    { data: BodyType<SaveNicheBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveNiche>>,
  TError,
  { data: BodyType<SaveNicheBody> },
  TContext
> => {
  return useMutation(getSaveNicheMutationOptions(options));
};

/**
 * @summary Remove a saved niche
 */
export const getDeleteSavedNicheUrl = (id: string) => {
  return `/api/searches/saved-niches/${id}`;
};

export const deleteSavedNiche = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteSavedNicheUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteSavedNicheMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSavedNiche>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSavedNiche>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteSavedNiche"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSavedNiche>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteSavedNiche(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSavedNicheMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSavedNiche>>
>;

export type DeleteSavedNicheMutationError = ErrorType<void>;

/**
 * @summary Remove a saved niche
 */
export const useDeleteSavedNiche = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSavedNiche>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSavedNiche>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteSavedNicheMutationOptions(options));
};

/**
 * @summary List the operator's saved city/state combos
 */
export const getListSavedCitiesUrl = () => {
  return `/api/searches/saved-cities`;
};

export const listSavedCities = async (
  options?: RequestInit,
): Promise<SavedCity[]> => {
  return customFetch<SavedCity[]>(getListSavedCitiesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListSavedCitiesQueryKey = () => {
  return [`/api/searches/saved-cities`] as const;
};

export const getListSavedCitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof listSavedCities>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSavedCities>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSavedCitiesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSavedCities>>> = ({
    signal,
  }) => listSavedCities({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSavedCities>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSavedCitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSavedCities>>
>;
export type ListSavedCitiesQueryError = ErrorType<unknown>;

/**
 * @summary List the operator's saved city/state combos
 */

export function useListSavedCities<
  TData = Awaited<ReturnType<typeof listSavedCities>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSavedCities>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSavedCitiesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Save a city/state combo to the operator's list
 */
export const getSaveCityUrl = () => {
  return `/api/searches/saved-cities`;
};

export const saveCity = async (
  saveCityBody: SaveCityBody,
  options?: RequestInit,
): Promise<SavedCity> => {
  return customFetch<SavedCity>(getSaveCityUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(saveCityBody),
  });
};

export const getSaveCityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveCity>>,
    TError,
    { data: BodyType<SaveCityBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveCity>>,
  TError,
  { data: BodyType<SaveCityBody> },
  TContext
> => {
  const mutationKey = ["saveCity"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveCity>>,
    { data: BodyType<SaveCityBody> }
  > = (props) => {
    const { data } = props ?? {};

    return saveCity(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveCityMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveCity>>
>;
export type SaveCityMutationBody = BodyType<SaveCityBody>;
export type SaveCityMutationError = ErrorType<unknown>;

/**
 * @summary Save a city/state combo to the operator's list
 */
export const useSaveCity = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveCity>>,
    TError,
    { data: BodyType<SaveCityBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveCity>>,
  TError,
  { data: BodyType<SaveCityBody> },
  TContext
> => {
  return useMutation(getSaveCityMutationOptions(options));
};

/**
 * @summary Remove a saved city
 */
export const getDeleteSavedCityUrl = (id: string) => {
  return `/api/searches/saved-cities/${id}`;
};

export const deleteSavedCity = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteSavedCityUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteSavedCityMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSavedCity>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSavedCity>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteSavedCity"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSavedCity>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteSavedCity(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSavedCityMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSavedCity>>
>;

export type DeleteSavedCityMutationError = ErrorType<void>;

/**
 * @summary Remove a saved city
 */
export const useDeleteSavedCity = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSavedCity>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSavedCity>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteSavedCityMutationOptions(options));
};

/**
 * Creates one lead from a small hand-entered form (referrals,
trade-show conversations, etc.) without going through SerpAPI
discovery or CSV import. Runs the same scoring engine as bulk
import and optionally probes the supplied website URL to
enrich `site_*` fields. Dedupes by lowercased
`(business_name, city, state)` per operator so submitting the
same business twice updates the existing row instead of
creating a duplicate.

 * @summary Manually create a single lead from operator-entered fields
 */
export const getCreateLeadUrl = () => {
  return `/api/leads`;
};

export const createLead = async (
  createLeadBody: CreateLeadBody,
  options?: RequestInit,
): Promise<Lead> => {
  return customFetch<Lead>(getCreateLeadUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createLeadBody),
  });
};

export const getCreateLeadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLead>>,
    TError,
    { data: BodyType<CreateLeadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createLead>>,
  TError,
  { data: BodyType<CreateLeadBody> },
  TContext
> => {
  const mutationKey = ["createLead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createLead>>,
    { data: BodyType<CreateLeadBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createLead(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateLeadMutationResult = NonNullable<
  Awaited<ReturnType<typeof createLead>>
>;
export type CreateLeadMutationBody = BodyType<CreateLeadBody>;
export type CreateLeadMutationError = ErrorType<unknown>;

/**
 * @summary Manually create a single lead from operator-entered fields
 */
export const useCreateLead = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLead>>,
    TError,
    { data: BodyType<CreateLeadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createLead>>,
  TError,
  { data: BodyType<CreateLeadBody> },
  TContext
> => {
  return useMutation(getCreateLeadMutationOptions(options));
};

/**
 * Returns a paginated slice of the operator's leads along with the
total count for the active filter set. The dashboard pages 25 at
a time; `total` lets the UI render page-N-of-M without a second
round-trip. All filter params apply identically to
`GET /leads/stats` so the summary cards stay in sync with the
visible page.

 * @summary List leads with optional filters and pagination
 */
export const getListLeadsUrl = (params?: ListLeadsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/leads?${stringifiedParams}`
    : `/api/leads`;
};

export const listLeads = async (
  params?: ListLeadsParams,
  options?: RequestInit,
): Promise<LeadList> => {
  return customFetch<LeadList>(getListLeadsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListLeadsQueryKey = (params?: ListLeadsParams) => {
  return [`/api/leads`, ...(params ? [params] : [])] as const;
};

export const getListLeadsQueryOptions = <
  TData = Awaited<ReturnType<typeof listLeads>>,
  TError = ErrorType<unknown>,
>(
  params?: ListLeadsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listLeads>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListLeadsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listLeads>>> = ({
    signal,
  }) => listLeads(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listLeads>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListLeadsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listLeads>>
>;
export type ListLeadsQueryError = ErrorType<unknown>;

/**
 * @summary List leads with optional filters and pagination
 */

export function useListLeads<
  TData = Awaited<ReturnType<typeof listLeads>>,
  TError = ErrorType<unknown>,
>(
  params?: ListLeadsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listLeads>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListLeadsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Same filter surface as `GET /leads`. Pass the active dashboard
filters to keep the summary cards aligned with the table.

 * @summary Dashboard stats and top leads
 */
export const getGetLeadStatsUrl = (params?: GetLeadStatsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/leads/stats?${stringifiedParams}`
    : `/api/leads/stats`;
};

export const getLeadStats = async (
  params?: GetLeadStatsParams,
  options?: RequestInit,
): Promise<LeadStats> => {
  return customFetch<LeadStats>(getGetLeadStatsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetLeadStatsQueryKey = (params?: GetLeadStatsParams) => {
  return [`/api/leads/stats`, ...(params ? [params] : [])] as const;
};

export const getGetLeadStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getLeadStats>>,
  TError = ErrorType<unknown>,
>(
  params?: GetLeadStatsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLeadStats>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLeadStatsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeadStats>>> = ({
    signal,
  }) => getLeadStats(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLeadStats>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLeadStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLeadStats>>
>;
export type GetLeadStatsQueryError = ErrorType<unknown>;

/**
 * @summary Dashboard stats and top leads
 */

export function useGetLeadStats<
  TData = Awaited<ReturnType<typeof getLeadStats>>,
  TError = ErrorType<unknown>,
>(
  params?: GetLeadStatsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLeadStats>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLeadStatsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns last-N-day counts for each outcome bucket in the call
funnel (dials → contacts → DMs reached → interested →
demo permission granted) plus a contact-rate percentage.
Scoped to the authenticated operator's own calls via RLS.

 * @summary Weekly call-outcome funnel
 */
export const getGetCallFunnelUrl = (params?: GetCallFunnelParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/stats/call-funnel?${stringifiedParams}`
    : `/api/stats/call-funnel`;
};

export const getCallFunnel = async (
  params?: GetCallFunnelParams,
  options?: RequestInit,
): Promise<CallFunnelStats> => {
  return customFetch<CallFunnelStats>(getGetCallFunnelUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetCallFunnelQueryKey = (params?: GetCallFunnelParams) => {
  return [`/api/stats/call-funnel`, ...(params ? [params] : [])] as const;
};

export const getGetCallFunnelQueryOptions = <
  TData = Awaited<ReturnType<typeof getCallFunnel>>,
  TError = ErrorType<unknown>,
>(
  params?: GetCallFunnelParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCallFunnel>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCallFunnelQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCallFunnel>>> = ({
    signal,
  }) => getCallFunnel(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCallFunnel>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCallFunnelQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCallFunnel>>
>;
export type GetCallFunnelQueryError = ErrorType<unknown>;

/**
 * @summary Weekly call-outcome funnel
 */

export function useGetCallFunnel<
  TData = Awaited<ReturnType<typeof getCallFunnel>>,
  TError = ErrorType<unknown>,
>(
  params?: GetCallFunnelParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCallFunnel>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCallFunnelQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns the geocoded slice of the operator's leads as a compact
pin payload tailored for the dashboard Map view (Task 132).
Only leads with a non-null `latitude` AND `longitude` are
included in `pins`. The endpoint accepts the same filter
surface as `GET /leads` so the Map view stays in lock-step with
the FilterBar / Table / Board, and surfaces both the matched
total and the count of leads filtered out for missing
coordinates so the UI can render the
"📍 N leads not mappable" footer without a second round-trip.

 * @summary Lightweight pin payload for the map view
 */
export const getListLeadMapPinsUrl = (params?: ListLeadMapPinsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/leads/map?${stringifiedParams}`
    : `/api/leads/map`;
};

export const listLeadMapPins = async (
  params?: ListLeadMapPinsParams,
  options?: RequestInit,
): Promise<LeadMapResponse> => {
  return customFetch<LeadMapResponse>(getListLeadMapPinsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListLeadMapPinsQueryKey = (params?: ListLeadMapPinsParams) => {
  return [`/api/leads/map`, ...(params ? [params] : [])] as const;
};

export const getListLeadMapPinsQueryOptions = <
  TData = Awaited<ReturnType<typeof listLeadMapPins>>,
  TError = ErrorType<unknown>,
>(
  params?: ListLeadMapPinsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listLeadMapPins>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListLeadMapPinsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listLeadMapPins>>> = ({
    signal,
  }) => listLeadMapPins(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listLeadMapPins>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListLeadMapPinsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listLeadMapPins>>
>;
export type ListLeadMapPinsQueryError = ErrorType<unknown>;

/**
 * @summary Lightweight pin payload for the map view
 */

export function useListLeadMapPins<
  TData = Awaited<ReturnType<typeof listLeadMapPins>>,
  TError = ErrorType<unknown>,
>(
  params?: ListLeadMapPinsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listLeadMapPins>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListLeadMapPinsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns the distinct cities, states and business types that
actually exist on this operator's leads, so the filter dropdowns
only show options the operator can match. All arrays are sorted
alphabetically and exclude null/empty values.

 * @summary Distinct dropdown values for the dashboard filter bar
 */
export const getGetLeadFacetsUrl = () => {
  return `/api/leads/facets`;
};

export const getLeadFacets = async (
  options?: RequestInit,
): Promise<LeadFacets> => {
  return customFetch<LeadFacets>(getGetLeadFacetsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetLeadFacetsQueryKey = () => {
  return [`/api/leads/facets`] as const;
};

export const getGetLeadFacetsQueryOptions = <
  TData = Awaited<ReturnType<typeof getLeadFacets>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getLeadFacets>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLeadFacetsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeadFacets>>> = ({
    signal,
  }) => getLeadFacets({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLeadFacets>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLeadFacetsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLeadFacets>>
>;
export type GetLeadFacetsQueryError = ErrorType<unknown>;

/**
 * @summary Distinct dropdown values for the dashboard filter bar
 */

export function useGetLeadFacets<
  TData = Awaited<ReturnType<typeof getLeadFacets>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getLeadFacets>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLeadFacetsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns the N most recent call-log entries across all of the
operator's leads, newest-first, each enriched with the lead's
business_name, business_type, city, state, and phone so the
dashboard card doesn't need a second round-trip per lead.

 * @summary Most recent call-log entries across all leads for this operator
 */
export const getGetRecentCallsUrl = (params?: GetRecentCallsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/leads/recent-calls?${stringifiedParams}`
    : `/api/leads/recent-calls`;
};

export const getRecentCalls = async (
  params?: GetRecentCallsParams,
  options?: RequestInit,
): Promise<RecentCallList> => {
  return customFetch<RecentCallList>(getGetRecentCallsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetRecentCallsQueryKey = (params?: GetRecentCallsParams) => {
  return [`/api/leads/recent-calls`, ...(params ? [params] : [])] as const;
};

export const getGetRecentCallsQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentCalls>>,
  TError = ErrorType<unknown>,
>(
  params?: GetRecentCallsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRecentCalls>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRecentCallsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRecentCalls>>> = ({
    signal,
  }) => getRecentCalls(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentCalls>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetRecentCallsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentCalls>>
>;
export type GetRecentCallsQueryError = ErrorType<unknown>;

/**
 * @summary Most recent call-log entries across all leads for this operator
 */

export function useGetRecentCalls<
  TData = Awaited<ReturnType<typeof getRecentCalls>>,
  TError = ErrorType<unknown>,
>(
  params?: GetRecentCallsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRecentCalls>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetRecentCallsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a single lead
 */
export const getGetLeadUrl = (id: string) => {
  return `/api/leads/${id}`;
};

export const getLead = async (
  id: string,
  options?: RequestInit,
): Promise<Lead> => {
  return customFetch<Lead>(getGetLeadUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetLeadQueryKey = (id: string) => {
  return [`/api/leads/${id}`] as const;
};

export const getGetLeadQueryOptions = <
  TData = Awaited<ReturnType<typeof getLead>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getLead>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLeadQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLead>>> = ({
    signal,
  }) => getLead(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getLead>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetLeadQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLead>>
>;
export type GetLeadQueryError = ErrorType<void>;

/**
 * @summary Get a single lead
 */

export function useGetLead<
  TData = Awaited<ReturnType<typeof getLead>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getLead>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLeadQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Partial update. Operator-editable fields cover the same shape
as the manual create form (name, trade, contact info, address,
website) plus the workflow fields (`pipeline_status`, `notes`,
`generated_prompt`, `ai_insight`). When any scoring-relevant
field changes (`business_type`, `website_url`, `has_website`,
`phone`, `google_rating`, `google_review_count`) the lead is
re-scored. If `website_url` changes and `probe_website` is true
(default), the new URL is also re-probed.

 * @summary Update a lead (basic contact fields, status, notes, generated prompt)
 */
export const getUpdateLeadUrl = (id: string) => {
  return `/api/leads/${id}`;
};

export const updateLead = async (
  id: string,
  updateLeadBody: UpdateLeadBody,
  options?: RequestInit,
): Promise<Lead> => {
  return customFetch<Lead>(getUpdateLeadUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateLeadBody),
  });
};

export const getUpdateLeadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLead>>,
    TError,
    { id: string; data: BodyType<UpdateLeadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateLead>>,
  TError,
  { id: string; data: BodyType<UpdateLeadBody> },
  TContext
> => {
  const mutationKey = ["updateLead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateLead>>,
    { id: string; data: BodyType<UpdateLeadBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateLead(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateLeadMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateLead>>
>;
export type UpdateLeadMutationBody = BodyType<UpdateLeadBody>;
export type UpdateLeadMutationError = ErrorType<unknown>;

/**
 * @summary Update a lead (basic contact fields, status, notes, generated prompt)
 */
export const useUpdateLead = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLead>>,
    TError,
    { id: string; data: BodyType<UpdateLeadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateLead>>,
  TError,
  { id: string; data: BodyType<UpdateLeadBody> },
  TContext
> => {
  return useMutation(getUpdateLeadMutationOptions(options));
};

/**
 * @summary Delete a lead
 */
export const getDeleteLeadUrl = (id: string) => {
  return `/api/leads/${id}`;
};

export const deleteLead = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteLeadUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteLeadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteLead>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteLead>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteLead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteLead>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteLead(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteLeadMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteLead>>
>;

export type DeleteLeadMutationError = ErrorType<unknown>;

/**
 * @summary Delete a lead
 */
export const useDeleteLead = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteLead>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteLead>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteLeadMutationOptions(options));
};

/**
 * Generates a 3-paragraph operator brief explaining why this is a good target.
 * @summary Generate AI insight for a lead
 */
export const getAnalyzeLeadUrl = (id: string) => {
  return `/api/leads/${id}/analyze`;
};

export const analyzeLead = async (
  id: string,
  options?: RequestInit,
): Promise<Lead> => {
  return customFetch<Lead>(getAnalyzeLeadUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getAnalyzeLeadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof analyzeLead>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof analyzeLead>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["analyzeLead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof analyzeLead>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return analyzeLead(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AnalyzeLeadMutationResult = NonNullable<
  Awaited<ReturnType<typeof analyzeLead>>
>;

export type AnalyzeLeadMutationError = ErrorType<unknown>;

/**
 * @summary Generate AI insight for a lead
 */
export const useAnalyzeLead = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof analyzeLead>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof analyzeLead>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getAnalyzeLeadMutationOptions(options));
};

/**
 * Inspects the lead's existing context (business profile, scoring
reasons, latest cold-call notes, prior discovery values, plus
the optional `source_text` body) and returns suggested values
for each Discovery field. The server NEVER writes the lead —
the operator reviews and confirms in the UI before any PATCH.

 * @summary AI-draft structured Discovery facts for a lead
 */
export const getDraftLeadDiscoveryUrl = (id: string) => {
  return `/api/leads/${id}/discovery/draft`;
};

export const draftLeadDiscovery = async (
  id: string,
  draftLeadDiscoveryBody?: DraftLeadDiscoveryBody,
  options?: RequestInit,
): Promise<DiscoveryDraft> => {
  return customFetch<DiscoveryDraft>(getDraftLeadDiscoveryUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(draftLeadDiscoveryBody),
  });
};

export const getDraftLeadDiscoveryMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof draftLeadDiscovery>>,
    TError,
    { id: string; data: BodyType<DraftLeadDiscoveryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof draftLeadDiscovery>>,
  TError,
  { id: string; data: BodyType<DraftLeadDiscoveryBody> },
  TContext
> => {
  const mutationKey = ["draftLeadDiscovery"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof draftLeadDiscovery>>,
    { id: string; data: BodyType<DraftLeadDiscoveryBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return draftLeadDiscovery(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DraftLeadDiscoveryMutationResult = NonNullable<
  Awaited<ReturnType<typeof draftLeadDiscovery>>
>;
export type DraftLeadDiscoveryMutationBody = BodyType<DraftLeadDiscoveryBody>;
export type DraftLeadDiscoveryMutationError = ErrorType<unknown>;

/**
 * @summary AI-draft structured Discovery facts for a lead
 */
export const useDraftLeadDiscovery = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof draftLeadDiscovery>>,
    TError,
    { id: string; data: BodyType<DraftLeadDiscoveryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof draftLeadDiscovery>>,
  TError,
  { id: string; data: BodyType<DraftLeadDiscoveryBody> },
  TContext
> => {
  return useMutation(getDraftLeadDiscoveryMutationOptions(options));
};

/**
 * Accepts a short audio file (MediaRecorder webm/ogg/mp4/wav),
transcribes it with OpenAI Whisper, and runs the same draft
extraction as `/leads/{id}/discovery/draft` so the operator
gets both the raw transcript and structured suggestions in
one round-trip. The lead is NEVER written; the operator
confirms in the UI.

 * @summary Transcribe a voice memo and draft Discovery facts
 */
export const getTranscribeLeadDiscoveryUrl = (id: string) => {
  return `/api/leads/${id}/discovery/transcribe`;
};

export const transcribeLeadDiscovery = async (
  id: string,
  transcribeLeadDiscoveryBody: TranscribeLeadDiscoveryBody,
  options?: RequestInit,
): Promise<DiscoveryTranscription> => {
  const formData = new FormData();
  formData.append(`audio`, transcribeLeadDiscoveryBody.audio);

  return customFetch<DiscoveryTranscription>(
    getTranscribeLeadDiscoveryUrl(id),
    {
      ...options,
      method: "POST",
      body: formData,
    },
  );
};

export const getTranscribeLeadDiscoveryMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transcribeLeadDiscovery>>,
    TError,
    { id: string; data: BodyType<TranscribeLeadDiscoveryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof transcribeLeadDiscovery>>,
  TError,
  { id: string; data: BodyType<TranscribeLeadDiscoveryBody> },
  TContext
> => {
  const mutationKey = ["transcribeLeadDiscovery"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof transcribeLeadDiscovery>>,
    { id: string; data: BodyType<TranscribeLeadDiscoveryBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return transcribeLeadDiscovery(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TranscribeLeadDiscoveryMutationResult = NonNullable<
  Awaited<ReturnType<typeof transcribeLeadDiscovery>>
>;
export type TranscribeLeadDiscoveryMutationBody =
  BodyType<TranscribeLeadDiscoveryBody>;
export type TranscribeLeadDiscoveryMutationError = ErrorType<unknown>;

/**
 * @summary Transcribe a voice memo and draft Discovery facts
 */
export const useTranscribeLeadDiscovery = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transcribeLeadDiscovery>>,
    TError,
    { id: string; data: BodyType<TranscribeLeadDiscoveryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof transcribeLeadDiscovery>>,
  TError,
  { id: string; data: BodyType<TranscribeLeadDiscoveryBody> },
  TContext
> => {
  return useMutation(getTranscribeLeadDiscoveryMutationOptions(options));
};

/**
 * Clears the pending `discovery_suggestions` bundle on the lead
(set by the post-call background extractor in Task #296). The
Lead Detail page calls this both when the operator applies the
bundle through the review modal and when they explicitly
dismiss it from the badge — so the "AI suggestions ready"
badge disappears in either case.

 * @summary Dismiss the queued AI Discovery suggestion bundle
 */
export const getDismissLeadDiscoverySuggestionsUrl = (id: string) => {
  return `/api/leads/${id}/discovery/suggestions`;
};

export const dismissLeadDiscoverySuggestions = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDismissLeadDiscoverySuggestionsUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDismissLeadDiscoverySuggestionsMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissLeadDiscoverySuggestions>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dismissLeadDiscoverySuggestions>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["dismissLeadDiscoverySuggestions"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dismissLeadDiscoverySuggestions>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return dismissLeadDiscoverySuggestions(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DismissLeadDiscoverySuggestionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof dismissLeadDiscoverySuggestions>>
>;

export type DismissLeadDiscoverySuggestionsMutationError = ErrorType<void>;

/**
 * @summary Dismiss the queued AI Discovery suggestion bundle
 */
export const useDismissLeadDiscoverySuggestions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissLeadDiscoverySuggestions>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dismissLeadDiscoverySuggestions>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(
    getDismissLeadDiscoverySuggestionsMutationOptions(options),
  );
};

/**
 * Accepts an array of rows (already parsed from a CSV or a pasted
spreadsheet). Each row is scored with the same engine used by
SerpAPI discovery. Optionally probes any provided website URL to
enrich `site_*` fields. Dedupes by lowercased
`(business_name, city, state)` per operator so re-importing the
same CSV updates rows instead of creating duplicates.

 * @summary Bulk import leads from CSV / pasted rows
 */
export const getImportLeadsUrl = () => {
  return `/api/leads/import`;
};

export const importLeads = async (
  importLeadsBody: ImportLeadsBody,
  options?: RequestInit,
): Promise<ImportResult> => {
  return customFetch<ImportResult>(getImportLeadsUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(importLeadsBody),
  });
};

export const getImportLeadsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importLeads>>,
    TError,
    { data: BodyType<ImportLeadsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof importLeads>>,
  TError,
  { data: BodyType<ImportLeadsBody> },
  TContext
> => {
  const mutationKey = ["importLeads"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof importLeads>>,
    { data: BodyType<ImportLeadsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return importLeads(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ImportLeadsMutationResult = NonNullable<
  Awaited<ReturnType<typeof importLeads>>
>;
export type ImportLeadsMutationBody = BodyType<ImportLeadsBody>;
export type ImportLeadsMutationError = ErrorType<unknown>;

/**
 * @summary Bulk import leads from CSV / pasted rows
 */
export const useImportLeads = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importLeads>>,
    TError,
    { data: BodyType<ImportLeadsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof importLeads>>,
  TError,
  { data: BodyType<ImportLeadsBody> },
  TContext
> => {
  return useMutation(getImportLeadsMutationOptions(options));
};

/**
 * Creates the per-lead `lead_projects` row (or returns the existing
one if Start was already pressed) and moves the lead to
`in_progress`. If the lead has a `generated_prompt`, that value is
used as the initial `ai_prompt` for the project workspace.
Cancel/park state is cleared.

When the optional `REPLIT_BOOTSTRAP_WEBHOOK_URL` automation is
configured, the AI prompt is also POSTed to that webhook to
spin up a Replit project automatically; the returned project
URL is captured into `lead_projects.frontend_url`. If the
automation is not configured or fails, the response still
succeeds — the failure is surfaced via `bootstrap_warning` so
the operator can fall back to the manual flow.

 * @summary Start a project workspace for this lead
 */
export const getStartLeadProjectUrl = (id: string) => {
  return `/api/leads/${id}/start`;
};

export const startLeadProject = async (
  id: string,
  options?: RequestInit,
): Promise<StartLeadProjectResponse> => {
  return customFetch<StartLeadProjectResponse>(getStartLeadProjectUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getStartLeadProjectMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startLeadProject>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startLeadProject>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["startLeadProject"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startLeadProject>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return startLeadProject(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartLeadProjectMutationResult = NonNullable<
  Awaited<ReturnType<typeof startLeadProject>>
>;

export type StartLeadProjectMutationError = ErrorType<void>;

/**
 * @summary Start a project workspace for this lead
 */
export const useStartLeadProject = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startLeadProject>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof startLeadProject>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getStartLeadProjectMutationOptions(options));
};

/**
 * Accepts a partial body — every section (AI prompt, frontend,
backend, auth & credentials, live website, DNS, client info,
payment) hits this same endpoint with just its own fields, so
each Save button on the workspace persists independently.

 * @summary Save a section of the project workspace
 */
export const getUpdateLeadProjectUrl = (id: string) => {
  return `/api/leads/${id}/project`;
};

export const updateLeadProject = async (
  id: string,
  updateLeadProjectBody: UpdateLeadProjectBody,
  options?: RequestInit,
): Promise<Lead> => {
  return customFetch<Lead>(getUpdateLeadProjectUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateLeadProjectBody),
  });
};

export const getUpdateLeadProjectMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLeadProject>>,
    TError,
    { id: string; data: BodyType<UpdateLeadProjectBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateLeadProject>>,
  TError,
  { id: string; data: BodyType<UpdateLeadProjectBody> },
  TContext
> => {
  const mutationKey = ["updateLeadProject"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateLeadProject>>,
    { id: string; data: BodyType<UpdateLeadProjectBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateLeadProject(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateLeadProjectMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateLeadProject>>
>;
export type UpdateLeadProjectMutationBody = BodyType<UpdateLeadProjectBody>;
export type UpdateLeadProjectMutationError = ErrorType<void>;

/**
 * @summary Save a section of the project workspace
 */
export const useUpdateLeadProject = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLeadProject>>,
    TError,
    { id: string; data: BodyType<UpdateLeadProjectBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateLeadProject>>,
  TError,
  { id: string; data: BodyType<UpdateLeadProjectBody> },
  TContext
> => {
  return useMutation(getUpdateLeadProjectMutationOptions(options));
};

/**
 * Re-runs the optional `REPLIT_BOOTSTRAP_WEBHOOK_URL` automation
for an existing project that has not yet captured a
`frontend_url`. Used when the very first auto-build attempt
failed (webhook unreachable, automation timed out) and the
operator wants to retry without re-creating the project row or
losing the AI prompt.

Returns 404 if the lead has no project yet (operator must
click Start Build first), and 409 if the project already has a
`frontend_url` (no retry needed). On success the response
mirrors `startLeadProject`: the refreshed lead and an optional
`bootstrap_warning` if the retry itself failed.

 * @summary Retry the auto-build webhook for an existing project
 */
export const getRetryLeadProjectBootstrapUrl = (id: string) => {
  return `/api/leads/${id}/project/retry-bootstrap`;
};

export const retryLeadProjectBootstrap = async (
  id: string,
  options?: RequestInit,
): Promise<StartLeadProjectResponse> => {
  return customFetch<StartLeadProjectResponse>(
    getRetryLeadProjectBootstrapUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getRetryLeadProjectBootstrapMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryLeadProjectBootstrap>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof retryLeadProjectBootstrap>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["retryLeadProjectBootstrap"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof retryLeadProjectBootstrap>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return retryLeadProjectBootstrap(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RetryLeadProjectBootstrapMutationResult = NonNullable<
  Awaited<ReturnType<typeof retryLeadProjectBootstrap>>
>;

export type RetryLeadProjectBootstrapMutationError = ErrorType<void>;

/**
 * @summary Retry the auto-build webhook for an existing project
 */
export const useRetryLeadProjectBootstrap = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryLeadProjectBootstrap>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof retryLeadProjectBootstrap>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getRetryLeadProjectBootstrapMutationOptions(options));
};

/**
 * Stamps `completed_at` on the project, moves the lead to
`completed`, and returns the refreshed lead.

 * @summary Mark the project workspace as completed
 */
export const getCompleteLeadProjectUrl = (id: string) => {
  return `/api/leads/${id}/project/complete`;
};

export const completeLeadProject = async (
  id: string,
  options?: RequestInit,
): Promise<Lead> => {
  return customFetch<Lead>(getCompleteLeadProjectUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getCompleteLeadProjectMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeLeadProject>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof completeLeadProject>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["completeLeadProject"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completeLeadProject>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return completeLeadProject(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompleteLeadProjectMutationResult = NonNullable<
  Awaited<ReturnType<typeof completeLeadProject>>
>;

export type CompleteLeadProjectMutationError = ErrorType<void>;

/**
 * @summary Mark the project workspace as completed
 */
export const useCompleteLeadProject = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeLeadProject>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof completeLeadProject>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getCompleteLeadProjectMutationOptions(options));
};

/**
 * Returns the call rows captured for this lead via the Cold Call
Sheet's capture pad, sorted newest-first. Paginated via `limit`
and `offset` query params.

 * @summary List call-log entries for a lead, newest first
 */
export const getListLeadCallsUrl = (
  id: string,
  params?: ListLeadCallsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/leads/${id}/calls?${stringifiedParams}`
    : `/api/leads/${id}/calls`;
};

export const listLeadCalls = async (
  id: string,
  params?: ListLeadCallsParams,
  options?: RequestInit,
): Promise<LeadCallList> => {
  return customFetch<LeadCallList>(getListLeadCallsUrl(id, params), {
    ...options,
    method: "GET",
  });
};

export const getListLeadCallsQueryKey = (
  id: string,
  params?: ListLeadCallsParams,
) => {
  return [`/api/leads/${id}/calls`, ...(params ? [params] : [])] as const;
};

export const getListLeadCallsQueryOptions = <
  TData = Awaited<ReturnType<typeof listLeadCalls>>,
  TError = ErrorType<void>,
>(
  id: string,
  params?: ListLeadCallsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listLeadCalls>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListLeadCallsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listLeadCalls>>> = ({
    signal,
  }) => listLeadCalls(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listLeadCalls>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListLeadCallsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listLeadCalls>>
>;
export type ListLeadCallsQueryError = ErrorType<void>;

/**
 * @summary List call-log entries for a lead, newest first
 */

export function useListLeadCalls<
  TData = Awaited<ReturnType<typeof listLeadCalls>>,
  TError = ErrorType<void>,
>(
  id: string,
  params?: ListLeadCallsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listLeadCalls>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListLeadCallsQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Records one row in the lead's call log. The same body also
atomically updates the parent lead row when the operator
learned new contact info (`owner_name`, `owner_email`,
`owner_cell`) or flipped the do-not-call flag, and routes the
lead through the right pipeline transition:

  - `do_not_call=true` (or `outcome='do_not_call'`) →
    lead.do_not_call=true, pipeline_status='lost'
  - `outcome='callback_scheduled'` requires `next_action_at` to
    be set and in the future (400 otherwise). Mirrors to
    lead.parked_until/parked_at and pipeline_status='parked'.
  - `demo_permission=true` & lead has no project yet → moves
    the lead to pipeline_status='demo_built'

Owner fields use tri-state semantics: omit to leave unchanged,
send a non-empty string to update, send `null` to clear.

 * @summary Log a cold-call attempt and apply downstream side-effects
 */
export const getCreateLeadCallUrl = (id: string) => {
  return `/api/leads/${id}/calls`;
};

export const createLeadCall = async (
  id: string,
  createLeadCallBody: CreateLeadCallBody,
  options?: RequestInit,
): Promise<CreateLeadCallResponse> => {
  return customFetch<CreateLeadCallResponse>(getCreateLeadCallUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createLeadCallBody),
  });
};

export const getCreateLeadCallMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLeadCall>>,
    TError,
    { id: string; data: BodyType<CreateLeadCallBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createLeadCall>>,
  TError,
  { id: string; data: BodyType<CreateLeadCallBody> },
  TContext
> => {
  const mutationKey = ["createLeadCall"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createLeadCall>>,
    { id: string; data: BodyType<CreateLeadCallBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createLeadCall(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateLeadCallMutationResult = NonNullable<
  Awaited<ReturnType<typeof createLeadCall>>
>;
export type CreateLeadCallMutationBody = BodyType<CreateLeadCallBody>;
export type CreateLeadCallMutationError = ErrorType<void>;

/**
 * @summary Log a cold-call attempt and apply downstream side-effects
 */
export const useCreateLeadCall = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLeadCall>>,
    TError,
    { id: string; data: BodyType<CreateLeadCallBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createLeadCall>>,
  TError,
  { id: string; data: BodyType<CreateLeadCallBody> },
  TContext
> => {
  return useMutation(getCreateLeadCallMutationOptions(options));
};

/**
 * @summary Cancel a lead with a structured reason
 */
export const getCancelLeadUrl = (id: string) => {
  return `/api/leads/${id}/cancel`;
};

export const cancelLead = async (
  id: string,
  cancelLeadBody: CancelLeadBody,
  options?: RequestInit,
): Promise<Lead> => {
  return customFetch<Lead>(getCancelLeadUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(cancelLeadBody),
  });
};

export const getCancelLeadMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelLead>>,
    TError,
    { id: string; data: BodyType<CancelLeadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelLead>>,
  TError,
  { id: string; data: BodyType<CancelLeadBody> },
  TContext
> => {
  const mutationKey = ["cancelLead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelLead>>,
    { id: string; data: BodyType<CancelLeadBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return cancelLead(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelLeadMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelLead>>
>;
export type CancelLeadMutationBody = BodyType<CancelLeadBody>;
export type CancelLeadMutationError = ErrorType<void>;

/**
 * @summary Cancel a lead with a structured reason
 */
export const useCancelLead = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelLead>>,
    TError,
    { id: string; data: BodyType<CancelLeadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof cancelLead>>,
  TError,
  { id: string; data: BodyType<CancelLeadBody> },
  TContext
> => {
  return useMutation(getCancelLeadMutationOptions(options));
};

/**
 * Sets `parked_until` to the supplied date, stamps `parked_at`,
and moves the lead to `parked`. The frontend defaults the picker
to 14 days out and enforces a minimum of tomorrow; the API only
requires that `parked_until` be strictly in the future.

 * @summary Park a lead until a future date
 */
export const getSaveLeadForLaterUrl = (id: string) => {
  return `/api/leads/${id}/save-for-later`;
};

export const saveLeadForLater = async (
  id: string,
  saveLeadForLaterBody: SaveLeadForLaterBody,
  options?: RequestInit,
): Promise<Lead> => {
  return customFetch<Lead>(getSaveLeadForLaterUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(saveLeadForLaterBody),
  });
};

export const getSaveLeadForLaterMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveLeadForLater>>,
    TError,
    { id: string; data: BodyType<SaveLeadForLaterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveLeadForLater>>,
  TError,
  { id: string; data: BodyType<SaveLeadForLaterBody> },
  TContext
> => {
  const mutationKey = ["saveLeadForLater"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveLeadForLater>>,
    { id: string; data: BodyType<SaveLeadForLaterBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return saveLeadForLater(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveLeadForLaterMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveLeadForLater>>
>;
export type SaveLeadForLaterMutationBody = BodyType<SaveLeadForLaterBody>;
export type SaveLeadForLaterMutationError = ErrorType<void>;

/**
 * @summary Park a lead until a future date
 */
export const useSaveLeadForLater = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveLeadForLater>>,
    TError,
    { id: string; data: BodyType<SaveLeadForLaterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveLeadForLater>>,
  TError,
  { id: string; data: BodyType<SaveLeadForLaterBody> },
  TContext
> => {
  return useMutation(getSaveLeadForLaterMutationOptions(options));
};

/**
 * Clears cancel + park state and resets `pipeline_status`. If a
project record exists, the lead returns to `in_progress`;
otherwise it returns to `reviewed` (preserves the operator's
earlier triage rather than reverting all the way to `new`).

 * @summary Bring a parked or cancelled lead back into the active pipeline
 */
export const getReactivateLeadUrl = (id: string) => {
  return `/api/leads/${id}/reactivate`;
};

export const reactivateLead = async (
  id: string,
  options?: RequestInit,
): Promise<Lead> => {
  return customFetch<Lead>(getReactivateLeadUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getReactivateLeadMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reactivateLead>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reactivateLead>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["reactivateLead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reactivateLead>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return reactivateLead(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReactivateLeadMutationResult = NonNullable<
  Awaited<ReturnType<typeof reactivateLead>>
>;

export type ReactivateLeadMutationError = ErrorType<void>;

/**
 * @summary Bring a parked or cancelled lead back into the active pipeline
 */
export const useReactivateLead = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reactivateLead>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reactivateLead>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getReactivateLeadMutationOptions(options));
};

/**
 * Returns a copy-pasteable prompt customized for this business — to drop into a Replit agent.
 * @summary Generate a website-build prompt for this lead
 */
export const getGenerateLeadPromptUrl = (id: string) => {
  return `/api/leads/${id}/generate-prompt`;
};

export const generateLeadPrompt = async (
  id: string,
  options?: RequestInit,
): Promise<Lead> => {
  return customFetch<Lead>(getGenerateLeadPromptUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getGenerateLeadPromptMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateLeadPrompt>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateLeadPrompt>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["generateLeadPrompt"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateLeadPrompt>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return generateLeadPrompt(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateLeadPromptMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateLeadPrompt>>
>;

export type GenerateLeadPromptMutationError = ErrorType<unknown>;

/**
 * @summary Generate a website-build prompt for this lead
 */
export const useGenerateLeadPrompt = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateLeadPrompt>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateLeadPrompt>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getGenerateLeadPromptMutationOptions(options));
};

/**
 * Used by the FollowUpPanel after a `voicemail` or `no_answer`
outcome. Returns a 12–18 second voicemail script that mentions a
specific weakness from the lead's dossier, and a 1–2 sentence
SMS body with the same weakness hook plus the operator's
configured signature. Both are editable in the UI before send.

 * @summary AI-draft a voicemail script + SMS body for a dead-call follow-up
 */
export const getDraftLeadFollowupUrl = (id: string) => {
  return `/api/leads/${id}/followup-draft`;
};

export const draftLeadFollowup = async (
  id: string,
  draftLeadFollowupBody?: DraftLeadFollowupBody,
  options?: RequestInit,
): Promise<LeadFollowupDraft> => {
  return customFetch<LeadFollowupDraft>(getDraftLeadFollowupUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(draftLeadFollowupBody),
  });
};

export const getDraftLeadFollowupMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof draftLeadFollowup>>,
    TError,
    { id: string; data: BodyType<DraftLeadFollowupBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof draftLeadFollowup>>,
  TError,
  { id: string; data: BodyType<DraftLeadFollowupBody> },
  TContext
> => {
  const mutationKey = ["draftLeadFollowup"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof draftLeadFollowup>>,
    { id: string; data: BodyType<DraftLeadFollowupBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return draftLeadFollowup(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DraftLeadFollowupMutationResult = NonNullable<
  Awaited<ReturnType<typeof draftLeadFollowup>>
>;
export type DraftLeadFollowupMutationBody = BodyType<DraftLeadFollowupBody>;
export type DraftLeadFollowupMutationError = ErrorType<void>;

/**
 * @summary AI-draft a voicemail script + SMS body for a dead-call follow-up
 */
export const useDraftLeadFollowup = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof draftLeadFollowup>>,
    TError,
    { id: string; data: BodyType<DraftLeadFollowupBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof draftLeadFollowup>>,
  TError,
  { id: string; data: BodyType<DraftLeadFollowupBody> },
  TContext
> => {
  return useMutation(getDraftLeadFollowupMutationOptions(options));
};

/**
 * Called when the operator confirms they actually left the
voicemail or sent the SMS for a previously logged call. The
text fields persist the (possibly edited) content that was
actually used so the call log can show it later.

 * @summary Stamp voicemail-left / SMS-sent on a logged call
 */
export const getMarkLeadCallFollowupUrl = (id: string, callId: string) => {
  return `/api/leads/${id}/calls/${callId}/followup-mark`;
};

export const markLeadCallFollowup = async (
  id: string,
  callId: string,
  markLeadCallFollowupBody: MarkLeadCallFollowupBody,
  options?: RequestInit,
): Promise<LeadCall> => {
  return customFetch<LeadCall>(getMarkLeadCallFollowupUrl(id, callId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(markLeadCallFollowupBody),
  });
};

export const getMarkLeadCallFollowupMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markLeadCallFollowup>>,
    TError,
    { id: string; callId: string; data: BodyType<MarkLeadCallFollowupBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markLeadCallFollowup>>,
  TError,
  { id: string; callId: string; data: BodyType<MarkLeadCallFollowupBody> },
  TContext
> => {
  const mutationKey = ["markLeadCallFollowup"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markLeadCallFollowup>>,
    { id: string; callId: string; data: BodyType<MarkLeadCallFollowupBody> }
  > = (props) => {
    const { id, callId, data } = props ?? {};

    return markLeadCallFollowup(id, callId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkLeadCallFollowupMutationResult = NonNullable<
  Awaited<ReturnType<typeof markLeadCallFollowup>>
>;
export type MarkLeadCallFollowupMutationBody =
  BodyType<MarkLeadCallFollowupBody>;
export type MarkLeadCallFollowupMutationError = ErrorType<void>;

/**
 * @summary Stamp voicemail-left / SMS-sent on a logged call
 */
export const useMarkLeadCallFollowup = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markLeadCallFollowup>>,
    TError,
    { id: string; callId: string; data: BodyType<MarkLeadCallFollowupBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof markLeadCallFollowup>>,
  TError,
  { id: string; callId: string; data: BodyType<MarkLeadCallFollowupBody> },
  TContext
> => {
  return useMutation(getMarkLeadCallFollowupMutationOptions(options));
};

/**
 * Used by the cold-call sheet's "Send instant demo" button. Builds
a branded mockup image based on the lead's dossier (business
name, trade, city, scraped colors / signals from the existing
site probe) and uploads it to object storage. Returns the
server-relative path the client should turn into an absolute
URL when composing the SMS body.

Generation is slow (typically 10–30 s — runs OpenAI image
generation server-side). The result is cached on the lead row,
so reopening the demo modal does NOT regenerate unless the
rep explicitly hits Regenerate, which can be requested by
passing `force: true`.

 * @summary Generate an AI-rendered demo screenshot of a hypothetical new homepage
 */
export const getGenerateLeadDemoUrl = (id: string) => {
  return `/api/leads/${id}/demo`;
};

export const generateLeadDemo = async (
  id: string,
  generateLeadDemoBody?: GenerateLeadDemoBody,
  options?: RequestInit,
): Promise<Lead> => {
  return customFetch<Lead>(getGenerateLeadDemoUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(generateLeadDemoBody),
  });
};

export const getGenerateLeadDemoMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateLeadDemo>>,
    TError,
    { id: string; data: BodyType<GenerateLeadDemoBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateLeadDemo>>,
  TError,
  { id: string; data: BodyType<GenerateLeadDemoBody> },
  TContext
> => {
  const mutationKey = ["generateLeadDemo"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateLeadDemo>>,
    { id: string; data: BodyType<GenerateLeadDemoBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return generateLeadDemo(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateLeadDemoMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateLeadDemo>>
>;
export type GenerateLeadDemoMutationBody = BodyType<GenerateLeadDemoBody>;
export type GenerateLeadDemoMutationError = ErrorType<void>;

/**
 * @summary Generate an AI-rendered demo screenshot of a hypothetical new homepage
 */
export const useGenerateLeadDemo = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateLeadDemo>>,
    TError,
    { id: string; data: BodyType<GenerateLeadDemoBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateLeadDemo>>,
  TError,
  { id: string; data: BodyType<GenerateLeadDemoBody> },
  TContext
> => {
  return useMutation(getGenerateLeadDemoMutationOptions(options));
};

/**
 * Forces a fresh capture of the lead's existing site.
 * @summary Re-capture the screenshot of the lead's existing website
 */
export const getRefreshLeadSiteThumbnailUrl = (id: string) => {
  return `/api/leads/${id}/refresh-thumbnail`;
};

export const refreshLeadSiteThumbnail = async (
  id: string,
  options?: RequestInit,
): Promise<Lead> => {
  return customFetch<Lead>(getRefreshLeadSiteThumbnailUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getRefreshLeadSiteThumbnailMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshLeadSiteThumbnail>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refreshLeadSiteThumbnail>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["refreshLeadSiteThumbnail"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refreshLeadSiteThumbnail>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return refreshLeadSiteThumbnail(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefreshLeadSiteThumbnailMutationResult = NonNullable<
  Awaited<ReturnType<typeof refreshLeadSiteThumbnail>>
>;

export type RefreshLeadSiteThumbnailMutationError = ErrorType<void>;

/**
 * @summary Re-capture the screenshot of the lead's existing website
 */
export const useRefreshLeadSiteThumbnail = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshLeadSiteThumbnail>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof refreshLeadSiteThumbnail>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getRefreshLeadSiteThumbnailMutationOptions(options));
};

/**
 * Idempotent — re-marking just refreshes the timestamp. The
client calls this the moment the SMS link is opened, since the
native Messages app does not callback on actual send/delivery.

 * @summary Stamp `demo_sent_at` after the rep hands off to their SMS app
 */
export const getMarkLeadDemoSentUrl = (id: string) => {
  return `/api/leads/${id}/demo/sent`;
};

export const markLeadDemoSent = async (
  id: string,
  options?: RequestInit,
): Promise<Lead> => {
  return customFetch<Lead>(getMarkLeadDemoSentUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getMarkLeadDemoSentMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markLeadDemoSent>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markLeadDemoSent>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["markLeadDemoSent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markLeadDemoSent>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return markLeadDemoSent(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkLeadDemoSentMutationResult = NonNullable<
  Awaited<ReturnType<typeof markLeadDemoSent>>
>;

export type MarkLeadDemoSentMutationError = ErrorType<void>;

/**
 * @summary Stamp `demo_sent_at` after the rep hands off to their SMS app
 */
export const useMarkLeadDemoSent = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markLeadDemoSent>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof markLeadDemoSent>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getMarkLeadDemoSentMutationOptions(options));
};

/**
 * @summary Read the operator's demo SMS body template
 */
export const getGetDemoMessagingConfigUrl = () => {
  return `/api/settings/demo-messaging`;
};

export const getDemoMessagingConfig = async (
  options?: RequestInit,
): Promise<DemoMessagingConfig> => {
  return customFetch<DemoMessagingConfig>(getGetDemoMessagingConfigUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetDemoMessagingConfigQueryKey = () => {
  return [`/api/settings/demo-messaging`] as const;
};

export const getGetDemoMessagingConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getDemoMessagingConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDemoMessagingConfig>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDemoMessagingConfigQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDemoMessagingConfig>>
  > = ({ signal }) => getDemoMessagingConfig({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDemoMessagingConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDemoMessagingConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDemoMessagingConfig>>
>;
export type GetDemoMessagingConfigQueryError = ErrorType<unknown>;

/**
 * @summary Read the operator's demo SMS body template
 */

export function useGetDemoMessagingConfig<
  TData = Awaited<ReturnType<typeof getDemoMessagingConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDemoMessagingConfig>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDemoMessagingConfigQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Upsert the operator's demo SMS body template
 */
export const getSaveDemoMessagingConfigUrl = () => {
  return `/api/settings/demo-messaging`;
};

export const saveDemoMessagingConfig = async (
  saveDemoMessagingBody: SaveDemoMessagingBody,
  options?: RequestInit,
): Promise<DemoMessagingConfig> => {
  return customFetch<DemoMessagingConfig>(getSaveDemoMessagingConfigUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(saveDemoMessagingBody),
  });
};

export const getSaveDemoMessagingConfigMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveDemoMessagingConfig>>,
    TError,
    { data: BodyType<SaveDemoMessagingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveDemoMessagingConfig>>,
  TError,
  { data: BodyType<SaveDemoMessagingBody> },
  TContext
> => {
  const mutationKey = ["saveDemoMessagingConfig"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveDemoMessagingConfig>>,
    { data: BodyType<SaveDemoMessagingBody> }
  > = (props) => {
    const { data } = props ?? {};

    return saveDemoMessagingConfig(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveDemoMessagingConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveDemoMessagingConfig>>
>;
export type SaveDemoMessagingConfigMutationBody =
  BodyType<SaveDemoMessagingBody>;
export type SaveDemoMessagingConfigMutationError = ErrorType<unknown>;

/**
 * @summary Upsert the operator's demo SMS body template
 */
export const useSaveDemoMessagingConfig = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveDemoMessagingConfig>>,
    TError,
    { data: BodyType<SaveDemoMessagingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveDemoMessagingConfig>>,
  TError,
  { data: BodyType<SaveDemoMessagingBody> },
  TContext
> => {
  return useMutation(getSaveDemoMessagingConfigMutationOptions(options));
};

/**
 * @summary Read the operator's voicemail/SMS tone guidance + signature
 */
export const getGetFollowupMessagingConfigUrl = () => {
  return `/api/settings/followup-messaging`;
};

export const getFollowupMessagingConfig = async (
  options?: RequestInit,
): Promise<FollowupMessagingConfig> => {
  return customFetch<FollowupMessagingConfig>(
    getGetFollowupMessagingConfigUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetFollowupMessagingConfigQueryKey = () => {
  return [`/api/settings/followup-messaging`] as const;
};

export const getGetFollowupMessagingConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getFollowupMessagingConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getFollowupMessagingConfig>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFollowupMessagingConfigQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFollowupMessagingConfig>>
  > = ({ signal }) => getFollowupMessagingConfig({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFollowupMessagingConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFollowupMessagingConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFollowupMessagingConfig>>
>;
export type GetFollowupMessagingConfigQueryError = ErrorType<unknown>;

/**
 * @summary Read the operator's voicemail/SMS tone guidance + signature
 */

export function useGetFollowupMessagingConfig<
  TData = Awaited<ReturnType<typeof getFollowupMessagingConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getFollowupMessagingConfig>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetFollowupMessagingConfigQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Upsert the operator's voicemail/SMS tone guidance + signature
 */
export const getSaveFollowupMessagingConfigUrl = () => {
  return `/api/settings/followup-messaging`;
};

export const saveFollowupMessagingConfig = async (
  saveFollowupMessagingBody: SaveFollowupMessagingBody,
  options?: RequestInit,
): Promise<FollowupMessagingConfig> => {
  return customFetch<FollowupMessagingConfig>(
    getSaveFollowupMessagingConfigUrl(),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(saveFollowupMessagingBody),
    },
  );
};

export const getSaveFollowupMessagingConfigMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveFollowupMessagingConfig>>,
    TError,
    { data: BodyType<SaveFollowupMessagingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveFollowupMessagingConfig>>,
  TError,
  { data: BodyType<SaveFollowupMessagingBody> },
  TContext
> => {
  const mutationKey = ["saveFollowupMessagingConfig"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveFollowupMessagingConfig>>,
    { data: BodyType<SaveFollowupMessagingBody> }
  > = (props) => {
    const { data } = props ?? {};

    return saveFollowupMessagingConfig(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveFollowupMessagingConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveFollowupMessagingConfig>>
>;
export type SaveFollowupMessagingConfigMutationBody =
  BodyType<SaveFollowupMessagingBody>;
export type SaveFollowupMessagingConfigMutationError = ErrorType<unknown>;

/**
 * @summary Upsert the operator's voicemail/SMS tone guidance + signature
 */
export const useSaveFollowupMessagingConfig = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveFollowupMessagingConfig>>,
    TError,
    { data: BodyType<SaveFollowupMessagingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveFollowupMessagingConfig>>,
  TError,
  { data: BodyType<SaveFollowupMessagingBody> },
  TContext
> => {
  return useMutation(getSaveFollowupMessagingConfigMutationOptions(options));
};

/**
 * @summary Read the operator's "notify me when a prospect opens their demo"
preferences (channel, contact details, quiet hours).

 */
export const getGetDemoViewNotificationsConfigUrl = () => {
  return `/api/settings/demo-view-notifications`;
};

export const getDemoViewNotificationsConfig = async (
  options?: RequestInit,
): Promise<DemoViewNotificationsConfig> => {
  return customFetch<DemoViewNotificationsConfig>(
    getGetDemoViewNotificationsConfigUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetDemoViewNotificationsConfigQueryKey = () => {
  return [`/api/settings/demo-view-notifications`] as const;
};

export const getGetDemoViewNotificationsConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getDemoViewNotificationsConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDemoViewNotificationsConfig>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDemoViewNotificationsConfigQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDemoViewNotificationsConfig>>
  > = ({ signal }) =>
    getDemoViewNotificationsConfig({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDemoViewNotificationsConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDemoViewNotificationsConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDemoViewNotificationsConfig>>
>;
export type GetDemoViewNotificationsConfigQueryError = ErrorType<unknown>;

/**
 * @summary Read the operator's "notify me when a prospect opens their demo"
preferences (channel, contact details, quiet hours).

 */

export function useGetDemoViewNotificationsConfig<
  TData = Awaited<ReturnType<typeof getDemoViewNotificationsConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDemoViewNotificationsConfig>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDemoViewNotificationsConfigQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Upsert the operator's demo-view notification preferences
 */
export const getSaveDemoViewNotificationsConfigUrl = () => {
  return `/api/settings/demo-view-notifications`;
};

export const saveDemoViewNotificationsConfig = async (
  saveDemoViewNotificationsBody: SaveDemoViewNotificationsBody,
  options?: RequestInit,
): Promise<DemoViewNotificationsConfig> => {
  return customFetch<DemoViewNotificationsConfig>(
    getSaveDemoViewNotificationsConfigUrl(),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(saveDemoViewNotificationsBody),
    },
  );
};

export const getSaveDemoViewNotificationsConfigMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveDemoViewNotificationsConfig>>,
    TError,
    { data: BodyType<SaveDemoViewNotificationsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveDemoViewNotificationsConfig>>,
  TError,
  { data: BodyType<SaveDemoViewNotificationsBody> },
  TContext
> => {
  const mutationKey = ["saveDemoViewNotificationsConfig"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveDemoViewNotificationsConfig>>,
    { data: BodyType<SaveDemoViewNotificationsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return saveDemoViewNotificationsConfig(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveDemoViewNotificationsConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveDemoViewNotificationsConfig>>
>;
export type SaveDemoViewNotificationsConfigMutationBody =
  BodyType<SaveDemoViewNotificationsBody>;
export type SaveDemoViewNotificationsConfigMutationError = ErrorType<unknown>;

/**
 * @summary Upsert the operator's demo-view notification preferences
 */
export const useSaveDemoViewNotificationsConfig = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveDemoViewNotificationsConfig>>,
    TError,
    { data: BodyType<SaveDemoViewNotificationsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveDemoViewNotificationsConfig>>,
  TError,
  { data: BodyType<SaveDemoViewNotificationsBody> },
  TContext
> => {
  return useMutation(
    getSaveDemoViewNotificationsConfigMutationOptions(options),
  );
};

/**
 * @summary List the rep's recent in-app notifications.
 */
export const getListNotificationsUrl = (params?: ListNotificationsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/notifications?${stringifiedParams}`
    : `/api/notifications`;
};

export const listNotifications = async (
  params?: ListNotificationsParams,
  options?: RequestInit,
): Promise<NotificationList> => {
  return customFetch<NotificationList>(getListNotificationsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListNotificationsQueryKey = (
  params?: ListNotificationsParams,
) => {
  return [`/api/notifications`, ...(params ? [params] : [])] as const;
};

export const getListNotificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listNotifications>>,
  TError = ErrorType<unknown>,
>(
  params?: ListNotificationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listNotifications>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListNotificationsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listNotifications>>
  > = ({ signal }) => listNotifications(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listNotifications>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListNotificationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listNotifications>>
>;
export type ListNotificationsQueryError = ErrorType<unknown>;

/**
 * @summary List the rep's recent in-app notifications.
 */

export function useListNotifications<
  TData = Awaited<ReturnType<typeof listNotifications>>,
  TError = ErrorType<unknown>,
>(
  params?: ListNotificationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listNotifications>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListNotificationsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Mark notifications as read. Pass `ids` to mark a subset; omit
the body to mark every unread row for the operator.

 */
export const getMarkNotificationsReadUrl = () => {
  return `/api/notifications/mark-read`;
};

export const markNotificationsRead = async (
  markNotificationsReadBody?: MarkNotificationsReadBody,
  options?: RequestInit,
): Promise<MarkNotificationsReadResponse> => {
  return customFetch<MarkNotificationsReadResponse>(
    getMarkNotificationsReadUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(markNotificationsReadBody),
    },
  );
};

export const getMarkNotificationsReadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markNotificationsRead>>,
    TError,
    { data: BodyType<MarkNotificationsReadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markNotificationsRead>>,
  TError,
  { data: BodyType<MarkNotificationsReadBody> },
  TContext
> => {
  const mutationKey = ["markNotificationsRead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markNotificationsRead>>,
    { data: BodyType<MarkNotificationsReadBody> }
  > = (props) => {
    const { data } = props ?? {};

    return markNotificationsRead(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkNotificationsReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof markNotificationsRead>>
>;
export type MarkNotificationsReadMutationBody =
  BodyType<MarkNotificationsReadBody>;
export type MarkNotificationsReadMutationError = ErrorType<unknown>;

/**
 * @summary Mark notifications as read. Pass `ids` to mark a subset; omit
the body to mark every unread row for the operator.

 */
export const useMarkNotificationsRead = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markNotificationsRead>>,
    TError,
    { data: BodyType<MarkNotificationsReadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof markNotificationsRead>>,
  TError,
  { data: BodyType<MarkNotificationsReadBody> },
  TContext
> => {
  return useMutation(getMarkNotificationsReadMutationOptions(options));
};

/**
 * @summary Read whether weekly auto-lookalikes are enabled for this operator
 */
export const getGetLookalikeAutoConfigUrl = () => {
  return `/api/settings/lookalike-auto`;
};

export const getLookalikeAutoConfig = async (
  options?: RequestInit,
): Promise<LookalikeAutoConfig> => {
  return customFetch<LookalikeAutoConfig>(getGetLookalikeAutoConfigUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetLookalikeAutoConfigQueryKey = () => {
  return [`/api/settings/lookalike-auto`] as const;
};

export const getGetLookalikeAutoConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getLookalikeAutoConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getLookalikeAutoConfig>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetLookalikeAutoConfigQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLookalikeAutoConfig>>
  > = ({ signal }) => getLookalikeAutoConfig({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLookalikeAutoConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLookalikeAutoConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLookalikeAutoConfig>>
>;
export type GetLookalikeAutoConfigQueryError = ErrorType<unknown>;

/**
 * @summary Read whether weekly auto-lookalikes are enabled for this operator
 */

export function useGetLookalikeAutoConfig<
  TData = Awaited<ReturnType<typeof getLookalikeAutoConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getLookalikeAutoConfig>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLookalikeAutoConfigQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Turn the weekly auto-lookalikes cron on or off for this operator
 */
export const getSaveLookalikeAutoConfigUrl = () => {
  return `/api/settings/lookalike-auto`;
};

export const saveLookalikeAutoConfig = async (
  saveLookalikeAutoConfigBody: SaveLookalikeAutoConfigBody,
  options?: RequestInit,
): Promise<SaveLookalikeAutoConfig200> => {
  return customFetch<SaveLookalikeAutoConfig200>(
    getSaveLookalikeAutoConfigUrl(),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(saveLookalikeAutoConfigBody),
    },
  );
};

export const getSaveLookalikeAutoConfigMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveLookalikeAutoConfig>>,
    TError,
    { data: BodyType<SaveLookalikeAutoConfigBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveLookalikeAutoConfig>>,
  TError,
  { data: BodyType<SaveLookalikeAutoConfigBody> },
  TContext
> => {
  const mutationKey = ["saveLookalikeAutoConfig"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveLookalikeAutoConfig>>,
    { data: BodyType<SaveLookalikeAutoConfigBody> }
  > = (props) => {
    const { data } = props ?? {};

    return saveLookalikeAutoConfig(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveLookalikeAutoConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveLookalikeAutoConfig>>
>;
export type SaveLookalikeAutoConfigMutationBody =
  BodyType<SaveLookalikeAutoConfigBody>;
export type SaveLookalikeAutoConfigMutationError = ErrorType<unknown>;

/**
 * @summary Turn the weekly auto-lookalikes cron on or off for this operator
 */
export const useSaveLookalikeAutoConfig = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveLookalikeAutoConfig>>,
    TError,
    { data: BodyType<SaveLookalikeAutoConfigBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveLookalikeAutoConfig>>,
  TError,
  { data: BodyType<SaveLookalikeAutoConfigBody> },
  TContext
> => {
  return useMutation(getSaveLookalikeAutoConfigMutationOptions(options));
};

/**
 * Returns the operator's per-rule opt-outs, monitored cities,
last cron timestamp, plus the platform-level rule catalog and
whether OpenWeather is wired up. Defaults are returned when no
row exists yet.

 * @summary Read this operator's surge-trigger config
 */
export const getGetSurgeTriggersConfigUrl = () => {
  return `/api/settings/surge-triggers`;
};

export const getSurgeTriggersConfig = async (
  options?: RequestInit,
): Promise<SurgeTriggersConfigResponse> => {
  return customFetch<SurgeTriggersConfigResponse>(
    getGetSurgeTriggersConfigUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetSurgeTriggersConfigQueryKey = () => {
  return [`/api/settings/surge-triggers`] as const;
};

export const getGetSurgeTriggersConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getSurgeTriggersConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getSurgeTriggersConfig>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSurgeTriggersConfigQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSurgeTriggersConfig>>
  > = ({ signal }) => getSurgeTriggersConfig({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSurgeTriggersConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSurgeTriggersConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSurgeTriggersConfig>>
>;
export type GetSurgeTriggersConfigQueryError = ErrorType<unknown>;

/**
 * @summary Read this operator's surge-trigger config
 */

export function useGetSurgeTriggersConfig<
  TData = Awaited<ReturnType<typeof getSurgeTriggersConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getSurgeTriggersConfig>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSurgeTriggersConfigQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Upsert this operator's surge-trigger config
 */
export const getSaveSurgeTriggersConfigUrl = () => {
  return `/api/settings/surge-triggers`;
};

export const saveSurgeTriggersConfig = async (
  saveSurgeTriggersConfigBody: SaveSurgeTriggersConfigBody,
  options?: RequestInit,
): Promise<SurgeTriggersConfigResponse> => {
  return customFetch<SurgeTriggersConfigResponse>(
    getSaveSurgeTriggersConfigUrl(),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(saveSurgeTriggersConfigBody),
    },
  );
};

export const getSaveSurgeTriggersConfigMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveSurgeTriggersConfig>>,
    TError,
    { data: BodyType<SaveSurgeTriggersConfigBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveSurgeTriggersConfig>>,
  TError,
  { data: BodyType<SaveSurgeTriggersConfigBody> },
  TContext
> => {
  const mutationKey = ["saveSurgeTriggersConfig"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveSurgeTriggersConfig>>,
    { data: BodyType<SaveSurgeTriggersConfigBody> }
  > = (props) => {
    const { data } = props ?? {};

    return saveSurgeTriggersConfig(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveSurgeTriggersConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveSurgeTriggersConfig>>
>;
export type SaveSurgeTriggersConfigMutationBody =
  BodyType<SaveSurgeTriggersConfigBody>;
export type SaveSurgeTriggersConfigMutationError = ErrorType<unknown>;

/**
 * @summary Upsert this operator's surge-trigger config
 */
export const useSaveSurgeTriggersConfig = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveSurgeTriggersConfig>>,
    TError,
    { data: BodyType<SaveSurgeTriggersConfigBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveSurgeTriggersConfig>>,
  TError,
  { data: BodyType<SaveSurgeTriggersConfigBody> },
  TContext
> => {
  return useMutation(getSaveSurgeTriggersConfigMutationOptions(options));
};

/**
 * Lets the Settings "Run now" button kick off a single-user
surge sweep without exposing the bearer-protected cron
endpoint to the browser. Same RLS scoping and budget caps as
the daily cron, but only walks the authenticated user's
cities.

 * @summary Trigger an immediate surge sweep for the current operator
 */
export const getRunSurgeTriggersForCurrentUserUrl = () => {
  return `/api/settings/surge-triggers/run-now`;
};

export const runSurgeTriggersForCurrentUser = async (
  options?: RequestInit,
): Promise<SurgeCronUserResult> => {
  return customFetch<SurgeCronUserResult>(
    getRunSurgeTriggersForCurrentUserUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getRunSurgeTriggersForCurrentUserMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runSurgeTriggersForCurrentUser>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runSurgeTriggersForCurrentUser>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["runSurgeTriggersForCurrentUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runSurgeTriggersForCurrentUser>>,
    void
  > = () => {
    return runSurgeTriggersForCurrentUser(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RunSurgeTriggersForCurrentUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof runSurgeTriggersForCurrentUser>>
>;

export type RunSurgeTriggersForCurrentUserMutationError = ErrorType<unknown>;

/**
 * @summary Trigger an immediate surge sweep for the current operator
 */
export const useRunSurgeTriggersForCurrentUser = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runSurgeTriggersForCurrentUser>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof runSurgeTriggersForCurrentUser>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getRunSurgeTriggersForCurrentUserMutationOptions(options));
};

/**
 * @summary Retrieve the operator's WhatsApp/Twilio configuration
 */
export const getGetWhatsappSettingsUrl = () => {
  return `/api/settings/whatsapp`;
};

export const getWhatsappSettings = async (
  options?: RequestInit,
): Promise<WhatsappConfig> => {
  return customFetch<WhatsappConfig>(getGetWhatsappSettingsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetWhatsappSettingsQueryKey = () => {
  return [`/api/settings/whatsapp`] as const;
};

export const getGetWhatsappSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getWhatsappSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getWhatsappSettings>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWhatsappSettingsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWhatsappSettings>>
  > = ({ signal }) => getWhatsappSettings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWhatsappSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWhatsappSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWhatsappSettings>>
>;
export type GetWhatsappSettingsQueryError = ErrorType<unknown>;

/**
 * @summary Retrieve the operator's WhatsApp/Twilio configuration
 */

export function useGetWhatsappSettings<
  TData = Awaited<ReturnType<typeof getWhatsappSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getWhatsappSettings>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWhatsappSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Save (or update) WhatsApp/Twilio credentials
 */
export const getSaveWhatsappSettingsUrl = () => {
  return `/api/settings/whatsapp`;
};

export const saveWhatsappSettings = async (
  saveWhatsappConfigBody: SaveWhatsappConfigBody,
  options?: RequestInit,
): Promise<SaveWhatsappSettings200> => {
  return customFetch<SaveWhatsappSettings200>(getSaveWhatsappSettingsUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(saveWhatsappConfigBody),
  });
};

export const getSaveWhatsappSettingsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveWhatsappSettings>>,
    TError,
    { data: BodyType<SaveWhatsappConfigBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveWhatsappSettings>>,
  TError,
  { data: BodyType<SaveWhatsappConfigBody> },
  TContext
> => {
  const mutationKey = ["saveWhatsappSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveWhatsappSettings>>,
    { data: BodyType<SaveWhatsappConfigBody> }
  > = (props) => {
    const { data } = props ?? {};

    return saveWhatsappSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveWhatsappSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveWhatsappSettings>>
>;
export type SaveWhatsappSettingsMutationBody = BodyType<SaveWhatsappConfigBody>;
export type SaveWhatsappSettingsMutationError = ErrorType<unknown>;

/**
 * @summary Save (or update) WhatsApp/Twilio credentials
 */
export const useSaveWhatsappSettings = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveWhatsappSettings>>,
    TError,
    { data: BodyType<SaveWhatsappConfigBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveWhatsappSettings>>,
  TError,
  { data: BodyType<SaveWhatsappConfigBody> },
  TContext
> => {
  return useMutation(getSaveWhatsappSettingsMutationOptions(options));
};

/**
 * @summary Remove the operator's WhatsApp/Twilio configuration
 */
export const getDeleteWhatsappSettingsUrl = () => {
  return `/api/settings/whatsapp`;
};

export const deleteWhatsappSettings = async (
  options?: RequestInit,
): Promise<DeleteWhatsappSettings200> => {
  return customFetch<DeleteWhatsappSettings200>(
    getDeleteWhatsappSettingsUrl(),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteWhatsappSettingsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteWhatsappSettings>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteWhatsappSettings>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["deleteWhatsappSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteWhatsappSettings>>,
    void
  > = () => {
    return deleteWhatsappSettings(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteWhatsappSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteWhatsappSettings>>
>;

export type DeleteWhatsappSettingsMutationError = ErrorType<unknown>;

/**
 * @summary Remove the operator's WhatsApp/Twilio configuration
 */
export const useDeleteWhatsappSettings = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteWhatsappSettings>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteWhatsappSettings>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getDeleteWhatsappSettingsMutationOptions(options));
};

/**
 * @summary Verify WhatsApp credentials against Twilio
 */
export const getTestWhatsappSettingsUrl = () => {
  return `/api/settings/whatsapp/test`;
};

export const testWhatsappSettings = async (
  options?: RequestInit,
): Promise<TestWhatsappSettings200> => {
  return customFetch<TestWhatsappSettings200>(getTestWhatsappSettingsUrl(), {
    ...options,
    method: "POST",
  });
};

export const getTestWhatsappSettingsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testWhatsappSettings>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof testWhatsappSettings>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["testWhatsappSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof testWhatsappSettings>>,
    void
  > = () => {
    return testWhatsappSettings(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TestWhatsappSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof testWhatsappSettings>>
>;

export type TestWhatsappSettingsMutationError = ErrorType<unknown>;

/**
 * @summary Verify WhatsApp credentials against Twilio
 */
export const useTestWhatsappSettings = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testWhatsappSettings>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof testWhatsappSettings>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getTestWhatsappSettingsMutationOptions(options));
};

/**
 * @summary List the operator's WhatsApp template entries
 */
export const getListWhatsappTemplatesUrl = () => {
  return `/api/settings/whatsapp/templates`;
};

export const listWhatsappTemplates = async (
  options?: RequestInit,
): Promise<ListWhatsappTemplates200> => {
  return customFetch<ListWhatsappTemplates200>(getListWhatsappTemplatesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListWhatsappTemplatesQueryKey = () => {
  return [`/api/settings/whatsapp/templates`] as const;
};

export const getListWhatsappTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof listWhatsappTemplates>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listWhatsappTemplates>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListWhatsappTemplatesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listWhatsappTemplates>>
  > = ({ signal }) => listWhatsappTemplates({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listWhatsappTemplates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListWhatsappTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listWhatsappTemplates>>
>;
export type ListWhatsappTemplatesQueryError = ErrorType<unknown>;

/**
 * @summary List the operator's WhatsApp template entries
 */

export function useListWhatsappTemplates<
  TData = Awaited<ReturnType<typeof listWhatsappTemplates>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listWhatsappTemplates>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListWhatsappTemplatesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Register a new WhatsApp template entry
 */
export const getCreateWhatsappTemplateUrl = () => {
  return `/api/settings/whatsapp/templates`;
};

export const createWhatsappTemplate = async (
  createWhatsappTemplateBody: CreateWhatsappTemplateBody,
  options?: RequestInit,
): Promise<CreateWhatsappTemplate201> => {
  return customFetch<CreateWhatsappTemplate201>(
    getCreateWhatsappTemplateUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(createWhatsappTemplateBody),
    },
  );
};

export const getCreateWhatsappTemplateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWhatsappTemplate>>,
    TError,
    { data: BodyType<CreateWhatsappTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createWhatsappTemplate>>,
  TError,
  { data: BodyType<CreateWhatsappTemplateBody> },
  TContext
> => {
  const mutationKey = ["createWhatsappTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createWhatsappTemplate>>,
    { data: BodyType<CreateWhatsappTemplateBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createWhatsappTemplate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateWhatsappTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createWhatsappTemplate>>
>;
export type CreateWhatsappTemplateMutationBody =
  BodyType<CreateWhatsappTemplateBody>;
export type CreateWhatsappTemplateMutationError = ErrorType<unknown>;

/**
 * @summary Register a new WhatsApp template entry
 */
export const useCreateWhatsappTemplate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWhatsappTemplate>>,
    TError,
    { data: BodyType<CreateWhatsappTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createWhatsappTemplate>>,
  TError,
  { data: BodyType<CreateWhatsappTemplateBody> },
  TContext
> => {
  return useMutation(getCreateWhatsappTemplateMutationOptions(options));
};

/**
 * @summary Update a WhatsApp template entry
 */
export const getUpdateWhatsappTemplateUrl = (id: string) => {
  return `/api/settings/whatsapp/templates/${id}`;
};

export const updateWhatsappTemplate = async (
  id: string,
  updateWhatsappTemplateBody: UpdateWhatsappTemplateBody,
  options?: RequestInit,
): Promise<UpdateWhatsappTemplate200> => {
  return customFetch<UpdateWhatsappTemplate200>(
    getUpdateWhatsappTemplateUrl(id),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateWhatsappTemplateBody),
    },
  );
};

export const getUpdateWhatsappTemplateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWhatsappTemplate>>,
    TError,
    { id: string; data: BodyType<UpdateWhatsappTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateWhatsappTemplate>>,
  TError,
  { id: string; data: BodyType<UpdateWhatsappTemplateBody> },
  TContext
> => {
  const mutationKey = ["updateWhatsappTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateWhatsappTemplate>>,
    { id: string; data: BodyType<UpdateWhatsappTemplateBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateWhatsappTemplate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateWhatsappTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateWhatsappTemplate>>
>;
export type UpdateWhatsappTemplateMutationBody =
  BodyType<UpdateWhatsappTemplateBody>;
export type UpdateWhatsappTemplateMutationError = ErrorType<unknown>;

/**
 * @summary Update a WhatsApp template entry
 */
export const useUpdateWhatsappTemplate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWhatsappTemplate>>,
    TError,
    { id: string; data: BodyType<UpdateWhatsappTemplateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateWhatsappTemplate>>,
  TError,
  { id: string; data: BodyType<UpdateWhatsappTemplateBody> },
  TContext
> => {
  return useMutation(getUpdateWhatsappTemplateMutationOptions(options));
};

/**
 * @summary Delete a WhatsApp template entry
 */
export const getDeleteWhatsappTemplateUrl = (id: string) => {
  return `/api/settings/whatsapp/templates/${id}`;
};

export const deleteWhatsappTemplate = async (
  id: string,
  options?: RequestInit,
): Promise<DeleteWhatsappTemplate200> => {
  return customFetch<DeleteWhatsappTemplate200>(
    getDeleteWhatsappTemplateUrl(id),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteWhatsappTemplateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteWhatsappTemplate>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteWhatsappTemplate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteWhatsappTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteWhatsappTemplate>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteWhatsappTemplate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteWhatsappTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteWhatsappTemplate>>
>;

export type DeleteWhatsappTemplateMutationError = ErrorType<unknown>;

/**
 * @summary Delete a WhatsApp template entry
 */
export const useDeleteWhatsappTemplate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteWhatsappTemplate>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteWhatsappTemplate>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteWhatsappTemplateMutationOptions(options));
};

/**
 * @summary Send a WhatsApp template message to a lead
 */
export const getSendLeadWhatsappUrl = (id: string) => {
  return `/api/leads/${id}/whatsapp/send`;
};

export const sendLeadWhatsapp = async (
  id: string,
  sendLeadWhatsappBody: SendLeadWhatsappBody,
  options?: RequestInit,
): Promise<SendLeadWhatsapp200> => {
  return customFetch<SendLeadWhatsapp200>(getSendLeadWhatsappUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(sendLeadWhatsappBody),
  });
};

export const getSendLeadWhatsappMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendLeadWhatsapp>>,
    TError,
    { id: string; data: BodyType<SendLeadWhatsappBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendLeadWhatsapp>>,
  TError,
  { id: string; data: BodyType<SendLeadWhatsappBody> },
  TContext
> => {
  const mutationKey = ["sendLeadWhatsapp"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendLeadWhatsapp>>,
    { id: string; data: BodyType<SendLeadWhatsappBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return sendLeadWhatsapp(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendLeadWhatsappMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendLeadWhatsapp>>
>;
export type SendLeadWhatsappMutationBody = BodyType<SendLeadWhatsappBody>;
export type SendLeadWhatsappMutationError = ErrorType<unknown>;

/**
 * @summary Send a WhatsApp template message to a lead
 */
export const useSendLeadWhatsapp = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendLeadWhatsapp>>,
    TError,
    { id: string; data: BodyType<SendLeadWhatsappBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendLeadWhatsapp>>,
  TError,
  { id: string; data: BodyType<SendLeadWhatsappBody> },
  TContext
> => {
  return useMutation(getSendLeadWhatsappMutationOptions(options));
};

/**
 * @summary List WhatsApp sends for a lead
 */
export const getGetLeadWhatsappHistoryUrl = (id: string) => {
  return `/api/leads/${id}/whatsapp/history`;
};

export const getLeadWhatsappHistory = async (
  id: string,
  options?: RequestInit,
): Promise<GetLeadWhatsappHistory200> => {
  return customFetch<GetLeadWhatsappHistory200>(
    getGetLeadWhatsappHistoryUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetLeadWhatsappHistoryQueryKey = (id: string) => {
  return [`/api/leads/${id}/whatsapp/history`] as const;
};

export const getGetLeadWhatsappHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getLeadWhatsappHistory>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLeadWhatsappHistory>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetLeadWhatsappHistoryQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLeadWhatsappHistory>>
  > = ({ signal }) => getLeadWhatsappHistory(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getLeadWhatsappHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLeadWhatsappHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLeadWhatsappHistory>>
>;
export type GetLeadWhatsappHistoryQueryError = ErrorType<unknown>;

/**
 * @summary List WhatsApp sends for a lead
 */

export function useGetLeadWhatsappHistory<
  TData = Awaited<ReturnType<typeof getLeadWhatsappHistory>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLeadWhatsappHistory>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLeadWhatsappHistoryQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Powers the dashboard "Surge Triggers" panel. Rows are already
snapshotted with label/severity/etc, so the client doesn't
need a second round-trip to render the panel.

 * @summary List every non-expired surge trigger for the operator
 */
export const getGetActiveSurgeTriggersUrl = () => {
  return `/api/triggers/active`;
};

export const getActiveSurgeTriggers = async (
  options?: RequestInit,
): Promise<ActiveSurgeTriggersResponse> => {
  return customFetch<ActiveSurgeTriggersResponse>(
    getGetActiveSurgeTriggersUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetActiveSurgeTriggersQueryKey = () => {
  return [`/api/triggers/active`] as const;
};

export const getGetActiveSurgeTriggersQueryOptions = <
  TData = Awaited<ReturnType<typeof getActiveSurgeTriggers>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getActiveSurgeTriggers>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetActiveSurgeTriggersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getActiveSurgeTriggers>>
  > = ({ signal }) => getActiveSurgeTriggers({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getActiveSurgeTriggers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetActiveSurgeTriggersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActiveSurgeTriggers>>
>;
export type GetActiveSurgeTriggersQueryError = ErrorType<unknown>;

/**
 * @summary List every non-expired surge trigger for the operator
 */

export function useGetActiveSurgeTriggers<
  TData = Awaited<ReturnType<typeof getActiveSurgeTriggers>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getActiveSurgeTriggers>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetActiveSurgeTriggersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Most recent lookalike batch for the operator (or null)
 */
export const getGetLatestLookalikeBatchUrl = () => {
  return `/api/lookalikes/latest`;
};

export const getLatestLookalikeBatch = async (
  options?: RequestInit,
): Promise<GetLatestLookalikeBatch200> => {
  return customFetch<GetLatestLookalikeBatch200>(
    getGetLatestLookalikeBatchUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetLatestLookalikeBatchQueryKey = () => {
  return [`/api/lookalikes/latest`] as const;
};

export const getGetLatestLookalikeBatchQueryOptions = <
  TData = Awaited<ReturnType<typeof getLatestLookalikeBatch>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getLatestLookalikeBatch>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetLatestLookalikeBatchQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLatestLookalikeBatch>>
  > = ({ signal }) => getLatestLookalikeBatch({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLatestLookalikeBatch>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLatestLookalikeBatchQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLatestLookalikeBatch>>
>;
export type GetLatestLookalikeBatchQueryError = ErrorType<unknown>;

/**
 * @summary Most recent lookalike batch for the operator (or null)
 */

export function useGetLatestLookalikeBatch<
  TData = Awaited<ReturnType<typeof getLatestLookalikeBatch>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getLatestLookalikeBatch>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLatestLookalikeBatchQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List past lookalike batch runs (newest first, last 20)
 */
export const getGetLookalikeBatchHistoryUrl = () => {
  return `/api/lookalikes/history`;
};

export const getLookalikeBatchHistory = async (
  options?: RequestInit,
): Promise<GetLookalikeBatchHistory200> => {
  return customFetch<GetLookalikeBatchHistory200>(
    getGetLookalikeBatchHistoryUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetLookalikeBatchHistoryQueryKey = () => {
  return [`/api/lookalikes/history`] as const;
};

export const getGetLookalikeBatchHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getLookalikeBatchHistory>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getLookalikeBatchHistory>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetLookalikeBatchHistoryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLookalikeBatchHistory>>
  > = ({ signal }) => getLookalikeBatchHistory({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLookalikeBatchHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLookalikeBatchHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLookalikeBatchHistory>>
>;
export type GetLookalikeBatchHistoryQueryError = ErrorType<unknown>;

/**
 * @summary List past lookalike batch runs (newest first, last 20)
 */

export function useGetLookalikeBatchHistory<
  TData = Awaited<ReturnType<typeof getLookalikeBatchHistory>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getLookalikeBatchHistory>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLookalikeBatchHistoryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Manually generate a lookalike batch from unseeded won leads
 */
export const getGenerateLookalikesUrl = () => {
  return `/api/lookalikes/generate`;
};

export const generateLookalikes = async (
  options?: RequestInit,
): Promise<GenerateLookalikes200> => {
  return customFetch<GenerateLookalikes200>(getGenerateLookalikesUrl(), {
    ...options,
    method: "POST",
  });
};

export const getGenerateLookalikesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateLookalikes>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateLookalikes>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["generateLookalikes"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateLookalikes>>,
    void
  > = () => {
    return generateLookalikes(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateLookalikesMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateLookalikes>>
>;

export type GenerateLookalikesMutationError = ErrorType<unknown>;

/**
 * @summary Manually generate a lookalike batch from unseeded won leads
 */
export const useGenerateLookalikes = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateLookalikes>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateLookalikes>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getGenerateLookalikesMutationOptions(options));
};

/**
 * Returns the top 3 same-trade Google Maps competitors within
~5 km of the lead, with a light site probe per result. The
result is cached on the lead row for 30 days; pass `refresh=1`
to force a re-fetch from SerpAPI.

 * @summary Top-3 same-trade competitors near the lead
 */
export const getGetLeadCompetitorsUrl = (
  id: string,
  params?: GetLeadCompetitorsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/leads/${id}/competitors?${stringifiedParams}`
    : `/api/leads/${id}/competitors`;
};

export const getLeadCompetitors = async (
  id: string,
  params?: GetLeadCompetitorsParams,
  options?: RequestInit,
): Promise<CompetitorList> => {
  return customFetch<CompetitorList>(getGetLeadCompetitorsUrl(id, params), {
    ...options,
    method: "GET",
  });
};

export const getGetLeadCompetitorsQueryKey = (
  id: string,
  params?: GetLeadCompetitorsParams,
) => {
  return [`/api/leads/${id}/competitors`, ...(params ? [params] : [])] as const;
};

export const getGetLeadCompetitorsQueryOptions = <
  TData = Awaited<ReturnType<typeof getLeadCompetitors>>,
  TError = ErrorType<void>,
>(
  id: string,
  params?: GetLeadCompetitorsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLeadCompetitors>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetLeadCompetitorsQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLeadCompetitors>>
  > = ({ signal }) =>
    getLeadCompetitors(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getLeadCompetitors>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLeadCompetitorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLeadCompetitors>>
>;
export type GetLeadCompetitorsQueryError = ErrorType<void>;

/**
 * @summary Top-3 same-trade competitors near the lead
 */

export function useGetLeadCompetitors<
  TData = Awaited<ReturnType<typeof getLeadCompetitors>>,
  TError = ErrorType<void>,
>(
  id: string,
  params?: GetLeadCompetitorsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLeadCompetitors>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLeadCompetitorsQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns the operator's library response for the given objection
key, rewritten by gpt-5-mini to mention something specific about
this lead. Cached per (user, lead, key) for 24 hours.

 * @summary Generate an AI-tailored rebuttal variant for a single objection
 */
export const getGenerateObjectionVariantUrl = (id: string) => {
  return `/api/leads/${id}/objection-variant`;
};

export const generateObjectionVariant = async (
  id: string,
  generateObjectionVariantBody: GenerateObjectionVariantBody,
  options?: RequestInit,
): Promise<ObjectionVariantResponse> => {
  return customFetch<ObjectionVariantResponse>(
    getGenerateObjectionVariantUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(generateObjectionVariantBody),
    },
  );
};

export const getGenerateObjectionVariantMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateObjectionVariant>>,
    TError,
    { id: string; data: BodyType<GenerateObjectionVariantBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateObjectionVariant>>,
  TError,
  { id: string; data: BodyType<GenerateObjectionVariantBody> },
  TContext
> => {
  const mutationKey = ["generateObjectionVariant"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateObjectionVariant>>,
    { id: string; data: BodyType<GenerateObjectionVariantBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return generateObjectionVariant(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateObjectionVariantMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateObjectionVariant>>
>;
export type GenerateObjectionVariantMutationBody =
  BodyType<GenerateObjectionVariantBody>;
export type GenerateObjectionVariantMutationError = ErrorType<void>;

/**
 * @summary Generate an AI-tailored rebuttal variant for a single objection
 */
export const useGenerateObjectionVariant = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateObjectionVariant>>,
    TError,
    { id: string; data: BodyType<GenerateObjectionVariantBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateObjectionVariant>>,
  TError,
  { id: string; data: BodyType<GenerateObjectionVariantBody> },
  TContext
> => {
  return useMutation(getGenerateObjectionVariantMutationOptions(options));
};

/**
 * Phase 4: paginated read-only feed of every council run the
operator has launched. The optional `q` query string filters
on the session's `input` (case-insensitive). Sessions are
ordered newest-first.

 * @summary List the operator's PromptHQ sessions (history page)
 */
export const getListPromptCouncilSessionsUrl = (
  params?: ListPromptCouncilSessionsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/prompt-council/sessions?${stringifiedParams}`
    : `/api/prompt-council/sessions`;
};

export const listPromptCouncilSessions = async (
  params?: ListPromptCouncilSessionsParams,
  options?: RequestInit,
): Promise<PromptCouncilSessionList> => {
  return customFetch<PromptCouncilSessionList>(
    getListPromptCouncilSessionsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListPromptCouncilSessionsQueryKey = (
  params?: ListPromptCouncilSessionsParams,
) => {
  return [`/api/prompt-council/sessions`, ...(params ? [params] : [])] as const;
};

export const getListPromptCouncilSessionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listPromptCouncilSessions>>,
  TError = ErrorType<unknown>,
>(
  params?: ListPromptCouncilSessionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPromptCouncilSessions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPromptCouncilSessionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPromptCouncilSessions>>
  > = ({ signal }) =>
    listPromptCouncilSessions(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPromptCouncilSessions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPromptCouncilSessionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPromptCouncilSessions>>
>;
export type ListPromptCouncilSessionsQueryError = ErrorType<unknown>;

/**
 * @summary List the operator's PromptHQ sessions (history page)
 */

export function useListPromptCouncilSessions<
  TData = Awaited<ReturnType<typeof listPromptCouncilSessions>>,
  TError = ErrorType<unknown>,
>(
  params?: ListPromptCouncilSessionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPromptCouncilSessions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPromptCouncilSessionsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Phase 1 of PromptHQ: takes the operator's freeform "describe
what you want to build" input, calls the Industry Savant
agent (Claude Sonnet) once, stores the row, and returns the
full session including the agent's Markdown output. Later
phases will run the rest of the agent chain on the same
session id.

 * @summary Run the PromptHQ Industry Savant agent and persist the session
 */
export const getCreatePromptCouncilSessionUrl = () => {
  return `/api/prompt-council/sessions`;
};

export const createPromptCouncilSession = async (
  createPromptCouncilSessionBody: CreatePromptCouncilSessionBody,
  options?: RequestInit,
): Promise<PromptCouncilSession> => {
  return customFetch<PromptCouncilSession>(getCreatePromptCouncilSessionUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createPromptCouncilSessionBody),
  });
};

export const getCreatePromptCouncilSessionMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPromptCouncilSession>>,
    TError,
    { data: BodyType<CreatePromptCouncilSessionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPromptCouncilSession>>,
  TError,
  { data: BodyType<CreatePromptCouncilSessionBody> },
  TContext
> => {
  const mutationKey = ["createPromptCouncilSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPromptCouncilSession>>,
    { data: BodyType<CreatePromptCouncilSessionBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createPromptCouncilSession(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePromptCouncilSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPromptCouncilSession>>
>;
export type CreatePromptCouncilSessionMutationBody =
  BodyType<CreatePromptCouncilSessionBody>;
export type CreatePromptCouncilSessionMutationError = ErrorType<void>;

/**
 * @summary Run the PromptHQ Industry Savant agent and persist the session
 */
export const useCreatePromptCouncilSession = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPromptCouncilSession>>,
    TError,
    { data: BodyType<CreatePromptCouncilSessionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPromptCouncilSession>>,
  TError,
  { data: BodyType<CreatePromptCouncilSessionBody> },
  TContext
> => {
  return useMutation(getCreatePromptCouncilSessionMutationOptions(options));
};

/**
 * Returns the most recent session for the authenticated operator
whose status is `running`, `paused`, `failed`, or the legacy
Phase 1 alias `error`. Used by the PromptHQ page (and the
dashboard's "Resume" link) to detect an in-progress run after
a tab close / refresh. Returns `{ session: null }` when there
is nothing to resume.

 * @summary Find the operator's currently in-flight session, if any
 */
export const getGetActivePromptCouncilSessionUrl = () => {
  return `/api/prompt-council/sessions/active`;
};

export const getActivePromptCouncilSession = async (
  options?: RequestInit,
): Promise<ActivePromptCouncilSessionResponse> => {
  return customFetch<ActivePromptCouncilSessionResponse>(
    getGetActivePromptCouncilSessionUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetActivePromptCouncilSessionQueryKey = () => {
  return [`/api/prompt-council/sessions/active`] as const;
};

export const getGetActivePromptCouncilSessionQueryOptions = <
  TData = Awaited<ReturnType<typeof getActivePromptCouncilSession>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getActivePromptCouncilSession>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetActivePromptCouncilSessionQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getActivePromptCouncilSession>>
  > = ({ signal }) =>
    getActivePromptCouncilSession({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getActivePromptCouncilSession>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetActivePromptCouncilSessionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActivePromptCouncilSession>>
>;
export type GetActivePromptCouncilSessionQueryError = ErrorType<unknown>;

/**
 * @summary Find the operator's currently in-flight session, if any
 */

export function useGetActivePromptCouncilSession<
  TData = Awaited<ReturnType<typeof getActivePromptCouncilSession>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getActivePromptCouncilSession>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetActivePromptCouncilSessionQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List the operator's saved filter presets for the history page
 */
export const getListPromptCouncilFilterPresetsUrl = () => {
  return `/api/prompt-council/sessions/filter-presets`;
};

export const listPromptCouncilFilterPresets = async (
  options?: RequestInit,
): Promise<PromptCouncilFilterPresetList> => {
  return customFetch<PromptCouncilFilterPresetList>(
    getListPromptCouncilFilterPresetsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListPromptCouncilFilterPresetsQueryKey = () => {
  return [`/api/prompt-council/sessions/filter-presets`] as const;
};

export const getListPromptCouncilFilterPresetsQueryOptions = <
  TData = Awaited<ReturnType<typeof listPromptCouncilFilterPresets>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPromptCouncilFilterPresets>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPromptCouncilFilterPresetsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPromptCouncilFilterPresets>>
  > = ({ signal }) =>
    listPromptCouncilFilterPresets({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPromptCouncilFilterPresets>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPromptCouncilFilterPresetsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPromptCouncilFilterPresets>>
>;
export type ListPromptCouncilFilterPresetsQueryError = ErrorType<unknown>;

/**
 * @summary List the operator's saved filter presets for the history page
 */

export function useListPromptCouncilFilterPresets<
  TData = Awaited<ReturnType<typeof listPromptCouncilFilterPresets>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPromptCouncilFilterPresets>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPromptCouncilFilterPresetsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Save a new filter preset for the history page
 */
export const getCreatePromptCouncilFilterPresetUrl = () => {
  return `/api/prompt-council/sessions/filter-presets`;
};

export const createPromptCouncilFilterPreset = async (
  createPromptCouncilFilterPresetBody: CreatePromptCouncilFilterPresetBody,
  options?: RequestInit,
): Promise<PromptCouncilFilterPreset> => {
  return customFetch<PromptCouncilFilterPreset>(
    getCreatePromptCouncilFilterPresetUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(createPromptCouncilFilterPresetBody),
    },
  );
};

export const getCreatePromptCouncilFilterPresetMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPromptCouncilFilterPreset>>,
    TError,
    { data: BodyType<CreatePromptCouncilFilterPresetBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPromptCouncilFilterPreset>>,
  TError,
  { data: BodyType<CreatePromptCouncilFilterPresetBody> },
  TContext
> => {
  const mutationKey = ["createPromptCouncilFilterPreset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPromptCouncilFilterPreset>>,
    { data: BodyType<CreatePromptCouncilFilterPresetBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createPromptCouncilFilterPreset(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePromptCouncilFilterPresetMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPromptCouncilFilterPreset>>
>;
export type CreatePromptCouncilFilterPresetMutationBody =
  BodyType<CreatePromptCouncilFilterPresetBody>;
export type CreatePromptCouncilFilterPresetMutationError = ErrorType<void>;

/**
 * @summary Save a new filter preset for the history page
 */
export const useCreatePromptCouncilFilterPreset = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPromptCouncilFilterPreset>>,
    TError,
    { data: BodyType<CreatePromptCouncilFilterPresetBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPromptCouncilFilterPreset>>,
  TError,
  { data: BodyType<CreatePromptCouncilFilterPresetBody> },
  TContext
> => {
  return useMutation(
    getCreatePromptCouncilFilterPresetMutationOptions(options),
  );
};

/**
 * @summary Delete a saved filter preset
 */
export const getDeletePromptCouncilFilterPresetUrl = (id: string) => {
  return `/api/prompt-council/sessions/filter-presets/${id}`;
};

export const deletePromptCouncilFilterPreset = async (
  id: string,
  options?: RequestInit,
): Promise<DeletePromptCouncilFilterPreset200> => {
  return customFetch<DeletePromptCouncilFilterPreset200>(
    getDeletePromptCouncilFilterPresetUrl(id),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeletePromptCouncilFilterPresetMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePromptCouncilFilterPreset>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePromptCouncilFilterPreset>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deletePromptCouncilFilterPreset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePromptCouncilFilterPreset>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deletePromptCouncilFilterPreset(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePromptCouncilFilterPresetMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePromptCouncilFilterPreset>>
>;

export type DeletePromptCouncilFilterPresetMutationError = ErrorType<void>;

/**
 * @summary Delete a saved filter preset
 */
export const useDeletePromptCouncilFilterPreset = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePromptCouncilFilterPreset>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deletePromptCouncilFilterPreset>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(
    getDeletePromptCouncilFilterPresetMutationOptions(options),
  );
};

/**
 * @summary Read a single PromptHQ session by id
 */
export const getGetPromptCouncilSessionUrl = (id: string) => {
  return `/api/prompt-council/sessions/${id}`;
};

export const getPromptCouncilSession = async (
  id: string,
  options?: RequestInit,
): Promise<PromptCouncilSession> => {
  return customFetch<PromptCouncilSession>(getGetPromptCouncilSessionUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetPromptCouncilSessionQueryKey = (id: string) => {
  return [`/api/prompt-council/sessions/${id}`] as const;
};

export const getGetPromptCouncilSessionQueryOptions = <
  TData = Awaited<ReturnType<typeof getPromptCouncilSession>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPromptCouncilSession>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPromptCouncilSessionQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPromptCouncilSession>>
  > = ({ signal }) =>
    getPromptCouncilSession(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPromptCouncilSession>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPromptCouncilSessionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPromptCouncilSession>>
>;
export type GetPromptCouncilSessionQueryError = ErrorType<void>;

/**
 * @summary Read a single PromptHQ session by id
 */

export function useGetPromptCouncilSession<
  TData = Awaited<ReturnType<typeof getPromptCouncilSession>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPromptCouncilSession>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPromptCouncilSessionQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Phase 4: hard-deletes the session row plus every related
`prompt_council_session_steps` and
`prompt_council_session_checkpoints` row. Used by the History
page's row-level Delete action.

 * @summary Delete a PromptHQ session and all of its steps + checkpoints
 */
export const getDeletePromptCouncilSessionUrl = (id: string) => {
  return `/api/prompt-council/sessions/${id}`;
};

export const deletePromptCouncilSession = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeletePromptCouncilSessionUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeletePromptCouncilSessionMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePromptCouncilSession>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePromptCouncilSession>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deletePromptCouncilSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePromptCouncilSession>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deletePromptCouncilSession(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePromptCouncilSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePromptCouncilSession>>
>;

export type DeletePromptCouncilSessionMutationError = ErrorType<void>;

/**
 * @summary Delete a PromptHQ session and all of its steps + checkpoints
 */
export const useDeletePromptCouncilSession = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePromptCouncilSession>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deletePromptCouncilSession>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeletePromptCouncilSessionMutationOptions(options));
};

/**
 * Advances the chain by exactly one agent. Each call stays well
under Vercel's 60-second function ceiling. Returns the updated
session and a `signal` telling the client what to do next:
`continue` (call again immediately), `checkpoint` (render the
steering UI), `complete` (chain done), `failed` (a step
errored, surface retry), or `idle` (nothing to do).

 * @summary Run the next pending step of a session
 */
export const getRunNextPromptCouncilStepUrl = (id: string) => {
  return `/api/prompt-council/sessions/${id}/run-next`;
};

export const runNextPromptCouncilStep = async (
  id: string,
  options?: RequestInit,
): Promise<RunNextPromptCouncilStepResponse> => {
  return customFetch<RunNextPromptCouncilStepResponse>(
    getRunNextPromptCouncilStepUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getRunNextPromptCouncilStepMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runNextPromptCouncilStep>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runNextPromptCouncilStep>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["runNextPromptCouncilStep"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runNextPromptCouncilStep>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return runNextPromptCouncilStep(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RunNextPromptCouncilStepMutationResult = NonNullable<
  Awaited<ReturnType<typeof runNextPromptCouncilStep>>
>;

export type RunNextPromptCouncilStepMutationError = ErrorType<void>;

/**
 * @summary Run the next pending step of a session
 */
export const useRunNextPromptCouncilStep = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runNextPromptCouncilStep>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof runNextPromptCouncilStep>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getRunNextPromptCouncilStepMutationOptions(options));
};

/**
 * Records the operator's optional steering note on the open
checkpoint, clears the session's `paused_at_checkpoint`, and
flips status back to `running`. The note is then forwarded
into every subsequent agent's input context.

 * @summary Resolve the open checkpoint and resume the chain
 */
export const getResolvePromptCouncilCheckpointUrl = (id: string) => {
  return `/api/prompt-council/sessions/${id}/resolve-checkpoint`;
};

export const resolvePromptCouncilCheckpoint = async (
  id: string,
  resolvePromptCouncilCheckpointBody: ResolvePromptCouncilCheckpointBody,
  options?: RequestInit,
): Promise<PromptCouncilSession> => {
  return customFetch<PromptCouncilSession>(
    getResolvePromptCouncilCheckpointUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(resolvePromptCouncilCheckpointBody),
    },
  );
};

export const getResolvePromptCouncilCheckpointMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resolvePromptCouncilCheckpoint>>,
    TError,
    { id: string; data: BodyType<ResolvePromptCouncilCheckpointBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resolvePromptCouncilCheckpoint>>,
  TError,
  { id: string; data: BodyType<ResolvePromptCouncilCheckpointBody> },
  TContext
> => {
  const mutationKey = ["resolvePromptCouncilCheckpoint"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resolvePromptCouncilCheckpoint>>,
    { id: string; data: BodyType<ResolvePromptCouncilCheckpointBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return resolvePromptCouncilCheckpoint(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResolvePromptCouncilCheckpointMutationResult = NonNullable<
  Awaited<ReturnType<typeof resolvePromptCouncilCheckpoint>>
>;
export type ResolvePromptCouncilCheckpointMutationBody =
  BodyType<ResolvePromptCouncilCheckpointBody>;
export type ResolvePromptCouncilCheckpointMutationError = ErrorType<void>;

/**
 * @summary Resolve the open checkpoint and resume the chain
 */
export const useResolvePromptCouncilCheckpoint = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resolvePromptCouncilCheckpoint>>,
    TError,
    { id: string; data: BodyType<ResolvePromptCouncilCheckpointBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resolvePromptCouncilCheckpoint>>,
  TError,
  { id: string; data: BodyType<ResolvePromptCouncilCheckpointBody> },
  TContext
> => {
  return useMutation(getResolvePromptCouncilCheckpointMutationOptions(options));
};

/**
 * Resets the latest step with status=`failed` back to `queued`
and flips the session back to `running`, so the next call to
`run-next` re-executes it with the same input context.

 * @summary Re-queue the most recently failed step
 */
export const getRetryPromptCouncilStepUrl = (id: string) => {
  return `/api/prompt-council/sessions/${id}/retry-step`;
};

export const retryPromptCouncilStep = async (
  id: string,
  options?: RequestInit,
): Promise<PromptCouncilSession> => {
  return customFetch<PromptCouncilSession>(getRetryPromptCouncilStepUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getRetryPromptCouncilStepMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryPromptCouncilStep>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof retryPromptCouncilStep>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["retryPromptCouncilStep"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof retryPromptCouncilStep>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return retryPromptCouncilStep(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RetryPromptCouncilStepMutationResult = NonNullable<
  Awaited<ReturnType<typeof retryPromptCouncilStep>>
>;

export type RetryPromptCouncilStepMutationError = ErrorType<void>;

/**
 * @summary Re-queue the most recently failed step
 */
export const useRetryPromptCouncilStep = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryPromptCouncilStep>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof retryPromptCouncilStep>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getRetryPromptCouncilStepMutationOptions(options));
};

/**
 * Sets `pause_requested = true` on the session. The next call
to `run-next` (or the background worker) honours the flag
after the current step completes by flipping status to
`paused` without inserting a checkpoint row. Use POST
`/resume` to continue. No-op for sessions that are not
currently `running`.

 * @summary Operator-initiated pause for a running session
 */
export const getRequestPausePromptCouncilSessionUrl = (id: string) => {
  return `/api/prompt-council/sessions/${id}/request-pause`;
};

export const requestPausePromptCouncilSession = async (
  id: string,
  options?: RequestInit,
): Promise<PromptCouncilSession> => {
  return customFetch<PromptCouncilSession>(
    getRequestPausePromptCouncilSessionUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getRequestPausePromptCouncilSessionMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestPausePromptCouncilSession>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestPausePromptCouncilSession>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["requestPausePromptCouncilSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestPausePromptCouncilSession>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return requestPausePromptCouncilSession(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestPausePromptCouncilSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestPausePromptCouncilSession>>
>;

export type RequestPausePromptCouncilSessionMutationError = ErrorType<void>;

/**
 * @summary Operator-initiated pause for a running session
 */
export const useRequestPausePromptCouncilSession = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestPausePromptCouncilSession>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestPausePromptCouncilSession>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(
    getRequestPausePromptCouncilSessionMutationOptions(options),
  );
};

/**
 * Flips an operator-paused session (paused without a steering
checkpoint) back to `running`. Refuses sessions paused at a
steering checkpoint — those must be resolved via
`/resolve-checkpoint`.

 * @summary Resume an operator-paused session
 */
export const getResumePromptCouncilSessionUrl = (id: string) => {
  return `/api/prompt-council/sessions/${id}/resume`;
};

export const resumePromptCouncilSession = async (
  id: string,
  options?: RequestInit,
): Promise<PromptCouncilSession> => {
  return customFetch<PromptCouncilSession>(
    getResumePromptCouncilSessionUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getResumePromptCouncilSessionMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resumePromptCouncilSession>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resumePromptCouncilSession>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["resumePromptCouncilSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resumePromptCouncilSession>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return resumePromptCouncilSession(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResumePromptCouncilSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof resumePromptCouncilSession>>
>;

export type ResumePromptCouncilSessionMutationError = ErrorType<void>;

/**
 * @summary Resume an operator-paused session
 */
export const useResumePromptCouncilSession = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resumePromptCouncilSession>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resumePromptCouncilSession>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getResumePromptCouncilSessionMutationOptions(options));
};

/**
 * Force-releases a step stuck in `running` state (i.e. the worker
crashed before it could mark it done or failed) and resumes the
session. Also handles sessions stuck in `paused` past the
checkpoint deadline.

 * @summary Unstick a stalled Prompt Council session
 */
export const getUnstickPromptCouncilSessionUrl = (id: string) => {
  return `/api/prompt-council/sessions/${id}/unstick`;
};

export const unstickPromptCouncilSession = async (
  id: string,
  options?: RequestInit,
): Promise<PromptCouncilSession> => {
  return customFetch<PromptCouncilSession>(
    getUnstickPromptCouncilSessionUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getUnstickPromptCouncilSessionMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unstickPromptCouncilSession>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unstickPromptCouncilSession>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["unstickPromptCouncilSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unstickPromptCouncilSession>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return unstickPromptCouncilSession(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnstickPromptCouncilSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof unstickPromptCouncilSession>>
>;

export type UnstickPromptCouncilSessionMutationError = ErrorType<void>;

/**
 * @summary Unstick a stalled Prompt Council session
 */
export const useUnstickPromptCouncilSession = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unstickPromptCouncilSession>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof unstickPromptCouncilSession>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getUnstickPromptCouncilSessionMutationOptions(options));
};

/**
 * Re-queues a specific `done` step (identified by `stepId`) and
clears every step that followed it (resetting them back to
`queued`, removing their output). The session is flipped back to
`running` so the auto-driver can continue. An optional
`steering_note` is appended to the step's input context so the
operator can guide the agent toward a different angle.
Rejected if the session is currently paused at a checkpoint.

 * @summary Re-run a single completed step with an optional extra steering note
 */
export const getRerunPromptCouncilStepUrl = (id: string, stepId: string) => {
  return `/api/prompt-council/sessions/${id}/steps/${stepId}/rerun`;
};

export const rerunPromptCouncilStep = async (
  id: string,
  stepId: string,
  rerunPromptCouncilStepBody: RerunPromptCouncilStepBody,
  options?: RequestInit,
): Promise<PromptCouncilSession> => {
  return customFetch<PromptCouncilSession>(
    getRerunPromptCouncilStepUrl(id, stepId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(rerunPromptCouncilStepBody),
    },
  );
};

export const getRerunPromptCouncilStepMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rerunPromptCouncilStep>>,
    TError,
    { id: string; stepId: string; data: BodyType<RerunPromptCouncilStepBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rerunPromptCouncilStep>>,
  TError,
  { id: string; stepId: string; data: BodyType<RerunPromptCouncilStepBody> },
  TContext
> => {
  const mutationKey = ["rerunPromptCouncilStep"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rerunPromptCouncilStep>>,
    { id: string; stepId: string; data: BodyType<RerunPromptCouncilStepBody> }
  > = (props) => {
    const { id, stepId, data } = props ?? {};

    return rerunPromptCouncilStep(id, stepId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RerunPromptCouncilStepMutationResult = NonNullable<
  Awaited<ReturnType<typeof rerunPromptCouncilStep>>
>;
export type RerunPromptCouncilStepMutationBody =
  BodyType<RerunPromptCouncilStepBody>;
export type RerunPromptCouncilStepMutationError = ErrorType<void>;

/**
 * @summary Re-run a single completed step with an optional extra steering note
 */
export const useRerunPromptCouncilStep = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rerunPromptCouncilStep>>,
    TError,
    { id: string; stepId: string; data: BodyType<RerunPromptCouncilStepBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof rerunPromptCouncilStep>>,
  TError,
  { id: string; stepId: string; data: BodyType<RerunPromptCouncilStepBody> },
  TContext
> => {
  return useMutation(getRerunPromptCouncilStepMutationOptions(options));
};

/**
 * Phase 4: creates a brand-new session that re-uses the source
session's input. Two modes:

  * "Re-run" (omit `fork_from_step`) seeds a fresh chain with
    every step queued. Set `skip_cache=true` to bypass the
    per-agent cache.
  * "Fork from step" (set `fork_from_step` to the position of
    the seat to keep): every step strictly before that
    position is copied verbatim into the new session as
    `done` (and the cache is consulted as usual for the rest).

Returns the new session ready for the client to start
polling `/run-next` against.

 * @summary Clone (re-run or fork) an existing PromptHQ session
 */
export const getClonePromptCouncilSessionUrl = (id: string) => {
  return `/api/prompt-council/sessions/${id}/clone`;
};

export const clonePromptCouncilSession = async (
  id: string,
  clonePromptCouncilSessionBody?: ClonePromptCouncilSessionBody,
  options?: RequestInit,
): Promise<PromptCouncilSession> => {
  return customFetch<PromptCouncilSession>(
    getClonePromptCouncilSessionUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(clonePromptCouncilSessionBody),
    },
  );
};

export const getClonePromptCouncilSessionMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof clonePromptCouncilSession>>,
    TError,
    { id: string; data: BodyType<ClonePromptCouncilSessionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof clonePromptCouncilSession>>,
  TError,
  { id: string; data: BodyType<ClonePromptCouncilSessionBody> },
  TContext
> => {
  const mutationKey = ["clonePromptCouncilSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof clonePromptCouncilSession>>,
    { id: string; data: BodyType<ClonePromptCouncilSessionBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return clonePromptCouncilSession(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ClonePromptCouncilSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof clonePromptCouncilSession>>
>;
export type ClonePromptCouncilSessionMutationBody =
  BodyType<ClonePromptCouncilSessionBody>;
export type ClonePromptCouncilSessionMutationError = ErrorType<void>;

/**
 * @summary Clone (re-run or fork) an existing PromptHQ session
 */
export const useClonePromptCouncilSession = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof clonePromptCouncilSession>>,
    TError,
    { id: string; data: BodyType<ClonePromptCouncilSessionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof clonePromptCouncilSession>>,
  TError,
  { id: string; data: BodyType<ClonePromptCouncilSessionBody> },
  TContext
> => {
  return useMutation(getClonePromptCouncilSessionMutationOptions(options));
};

/**
 * Phase 4: when an agent returns a structured clarifying
question, its step status flips to
`awaiting_clarification`. This endpoint records the
operator's chosen answer and re-queues the step (status
flips back to `queued` and the session back to `running`)
so the next `run-next` call re-executes the same agent
with the answer appended to its context. Returns the
updated session and a `continue` signal; the client must
poll `run-next` to actually re-run the agent.

 * @summary Answer the open clarifying question on a step
 */
export const getAnswerPromptCouncilClarificationUrl = (id: string) => {
  return `/api/prompt-council/sessions/${id}/answer-clarification`;
};

export const answerPromptCouncilClarification = async (
  id: string,
  answerPromptCouncilClarificationBody: AnswerPromptCouncilClarificationBody,
  options?: RequestInit,
): Promise<RunNextPromptCouncilStepResponse> => {
  return customFetch<RunNextPromptCouncilStepResponse>(
    getAnswerPromptCouncilClarificationUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(answerPromptCouncilClarificationBody),
    },
  );
};

export const getAnswerPromptCouncilClarificationMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof answerPromptCouncilClarification>>,
    TError,
    { id: string; data: BodyType<AnswerPromptCouncilClarificationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof answerPromptCouncilClarification>>,
  TError,
  { id: string; data: BodyType<AnswerPromptCouncilClarificationBody> },
  TContext
> => {
  const mutationKey = ["answerPromptCouncilClarification"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof answerPromptCouncilClarification>>,
    { id: string; data: BodyType<AnswerPromptCouncilClarificationBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return answerPromptCouncilClarification(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AnswerPromptCouncilClarificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof answerPromptCouncilClarification>>
>;
export type AnswerPromptCouncilClarificationMutationBody =
  BodyType<AnswerPromptCouncilClarificationBody>;
export type AnswerPromptCouncilClarificationMutationError = ErrorType<void>;

/**
 * @summary Answer the open clarifying question on a step
 */
export const useAnswerPromptCouncilClarification = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof answerPromptCouncilClarification>>,
    TError,
    { id: string; data: BodyType<AnswerPromptCouncilClarificationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof answerPromptCouncilClarification>>,
  TError,
  { id: string; data: BodyType<AnswerPromptCouncilClarificationBody> },
  TContext
> => {
  return useMutation(
    getAnswerPromptCouncilClarificationMutationOptions(options),
  );
};

/**
 * Returns every agent the operator owns, ordered by `position`.
On first read the standard 10-agent pack (Researcher,
Industry Savant, Skeptic, UX Designer, Monetization Strategist,
Philosopher, Web Architect, Replit Native, Scope Surgeon,
Prompt Architect) is seeded as their personal copy so the
editor never opens to an empty page.

 * @summary List the operator's PromptHQ agent council
 */
export const getListPromptCouncilAgentsUrl = () => {
  return `/api/prompt-council/agents`;
};

export const listPromptCouncilAgents = async (
  options?: RequestInit,
): Promise<PromptCouncilAgentList> => {
  return customFetch<PromptCouncilAgentList>(getListPromptCouncilAgentsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListPromptCouncilAgentsQueryKey = () => {
  return [`/api/prompt-council/agents`] as const;
};

export const getListPromptCouncilAgentsQueryOptions = <
  TData = Awaited<ReturnType<typeof listPromptCouncilAgents>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPromptCouncilAgents>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPromptCouncilAgentsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPromptCouncilAgents>>
  > = ({ signal }) => listPromptCouncilAgents({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPromptCouncilAgents>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPromptCouncilAgentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPromptCouncilAgents>>
>;
export type ListPromptCouncilAgentsQueryError = ErrorType<unknown>;

/**
 * @summary List the operator's PromptHQ agent council
 */

export function useListPromptCouncilAgents<
  TData = Awaited<ReturnType<typeof listPromptCouncilAgents>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPromptCouncilAgents>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPromptCouncilAgentsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Partial update of one agent. If either `system_prompt` or
`model` is changed, the prior values are snapshotted into
`prompt_council_agent_versions` before the update is applied,
so the operator can review and restore prior versions from
the editor's "version history" drawer.

 * @summary Update an agent's prompt, model, flags, or position
 */
export const getUpdatePromptCouncilAgentUrl = (id: string) => {
  return `/api/prompt-council/agents/${id}`;
};

export const updatePromptCouncilAgent = async (
  id: string,
  updatePromptCouncilAgentBody: UpdatePromptCouncilAgentBody,
  options?: RequestInit,
): Promise<PromptCouncilAgent> => {
  return customFetch<PromptCouncilAgent>(getUpdatePromptCouncilAgentUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updatePromptCouncilAgentBody),
  });
};

export const getUpdatePromptCouncilAgentMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePromptCouncilAgent>>,
    TError,
    { id: string; data: BodyType<UpdatePromptCouncilAgentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePromptCouncilAgent>>,
  TError,
  { id: string; data: BodyType<UpdatePromptCouncilAgentBody> },
  TContext
> => {
  const mutationKey = ["updatePromptCouncilAgent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePromptCouncilAgent>>,
    { id: string; data: BodyType<UpdatePromptCouncilAgentBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updatePromptCouncilAgent(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePromptCouncilAgentMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePromptCouncilAgent>>
>;
export type UpdatePromptCouncilAgentMutationBody =
  BodyType<UpdatePromptCouncilAgentBody>;
export type UpdatePromptCouncilAgentMutationError = ErrorType<void>;

/**
 * @summary Update an agent's prompt, model, flags, or position
 */
export const useUpdatePromptCouncilAgent = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePromptCouncilAgent>>,
    TError,
    { id: string; data: BodyType<UpdatePromptCouncilAgentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updatePromptCouncilAgent>>,
  TError,
  { id: string; data: BodyType<UpdatePromptCouncilAgentBody> },
  TContext
> => {
  return useMutation(getUpdatePromptCouncilAgentMutationOptions(options));
};

/**
 * Phase 4: hard-deletes every row in
`prompt_council_agent_cache` for the authenticated operator.
Used by the agents page's "Clear all caches" button when the
operator wants to reset both the Researcher and Industry
Savant caches at once.

 * @summary Clear every cached agent output for the operator
 */
export const getClearAllPromptCouncilAgentCachesUrl = () => {
  return `/api/prompt-council/agents/clear-cache`;
};

export const clearAllPromptCouncilAgentCaches = async (
  options?: RequestInit,
): Promise<ClearPromptCouncilCacheResponse> => {
  return customFetch<ClearPromptCouncilCacheResponse>(
    getClearAllPromptCouncilAgentCachesUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getClearAllPromptCouncilAgentCachesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof clearAllPromptCouncilAgentCaches>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof clearAllPromptCouncilAgentCaches>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["clearAllPromptCouncilAgentCaches"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof clearAllPromptCouncilAgentCaches>>,
    void
  > = () => {
    return clearAllPromptCouncilAgentCaches(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ClearAllPromptCouncilAgentCachesMutationResult = NonNullable<
  Awaited<ReturnType<typeof clearAllPromptCouncilAgentCaches>>
>;

export type ClearAllPromptCouncilAgentCachesMutationError = ErrorType<unknown>;

/**
 * @summary Clear every cached agent output for the operator
 */
export const useClearAllPromptCouncilAgentCaches = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof clearAllPromptCouncilAgentCaches>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof clearAllPromptCouncilAgentCaches>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getClearAllPromptCouncilAgentCachesMutationOptions(options),
  );
};

/**
 * Phase 4: deletes every row in `prompt_council_agent_cache`
for the authenticated operator + the agent identified by
path parameter `id`. Used by the agent editor's per-row
"Clear cache" action.

 * @summary Clear cached outputs for one agent
 */
export const getClearPromptCouncilAgentCacheUrl = (id: string) => {
  return `/api/prompt-council/agents/${id}/clear-cache`;
};

export const clearPromptCouncilAgentCache = async (
  id: string,
  options?: RequestInit,
): Promise<ClearPromptCouncilCacheResponse> => {
  return customFetch<ClearPromptCouncilCacheResponse>(
    getClearPromptCouncilAgentCacheUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getClearPromptCouncilAgentCacheMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof clearPromptCouncilAgentCache>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof clearPromptCouncilAgentCache>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["clearPromptCouncilAgentCache"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof clearPromptCouncilAgentCache>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return clearPromptCouncilAgentCache(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ClearPromptCouncilAgentCacheMutationResult = NonNullable<
  Awaited<ReturnType<typeof clearPromptCouncilAgentCache>>
>;

export type ClearPromptCouncilAgentCacheMutationError = ErrorType<void>;

/**
 * @summary Clear cached outputs for one agent
 */
export const useClearPromptCouncilAgentCache = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof clearPromptCouncilAgentCache>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof clearPromptCouncilAgentCache>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getClearPromptCouncilAgentCacheMutationOptions(options));
};

/**
 * Calls the agent identified by `id` once with the supplied
`input`, using the agent's stored `system_prompt` and `model`.
Used by the editor's "Test this agent" dialog so the operator
can preview how a prompt change behaves without committing to
a full council run. Does NOT create a session row.

 * @summary Run a single agent against a sample input (no session is persisted)
 */
export const getTestPromptCouncilAgentUrl = (id: string) => {
  return `/api/prompt-council/agents/${id}/test`;
};

export const testPromptCouncilAgent = async (
  id: string,
  testPromptCouncilAgentBody: TestPromptCouncilAgentBody,
  options?: RequestInit,
): Promise<TestPromptCouncilAgentResponse> => {
  return customFetch<TestPromptCouncilAgentResponse>(
    getTestPromptCouncilAgentUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(testPromptCouncilAgentBody),
    },
  );
};

export const getTestPromptCouncilAgentMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testPromptCouncilAgent>>,
    TError,
    { id: string; data: BodyType<TestPromptCouncilAgentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof testPromptCouncilAgent>>,
  TError,
  { id: string; data: BodyType<TestPromptCouncilAgentBody> },
  TContext
> => {
  const mutationKey = ["testPromptCouncilAgent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof testPromptCouncilAgent>>,
    { id: string; data: BodyType<TestPromptCouncilAgentBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return testPromptCouncilAgent(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TestPromptCouncilAgentMutationResult = NonNullable<
  Awaited<ReturnType<typeof testPromptCouncilAgent>>
>;
export type TestPromptCouncilAgentMutationBody =
  BodyType<TestPromptCouncilAgentBody>;
export type TestPromptCouncilAgentMutationError = ErrorType<void>;

/**
 * @summary Run a single agent against a sample input (no session is persisted)
 */
export const useTestPromptCouncilAgent = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testPromptCouncilAgent>>,
    TError,
    { id: string; data: BodyType<TestPromptCouncilAgentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof testPromptCouncilAgent>>,
  TError,
  { id: string; data: BodyType<TestPromptCouncilAgentBody> },
  TContext
> => {
  return useMutation(getTestPromptCouncilAgentMutationOptions(options));
};

/**
 * @summary List prior versions of an agent's system prompt
 */
export const getListPromptCouncilAgentVersionsUrl = (id: string) => {
  return `/api/prompt-council/agents/${id}/versions`;
};

export const listPromptCouncilAgentVersions = async (
  id: string,
  options?: RequestInit,
): Promise<PromptCouncilAgentVersionList> => {
  return customFetch<PromptCouncilAgentVersionList>(
    getListPromptCouncilAgentVersionsUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListPromptCouncilAgentVersionsQueryKey = (id: string) => {
  return [`/api/prompt-council/agents/${id}/versions`] as const;
};

export const getListPromptCouncilAgentVersionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listPromptCouncilAgentVersions>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPromptCouncilAgentVersions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPromptCouncilAgentVersionsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPromptCouncilAgentVersions>>
  > = ({ signal }) =>
    listPromptCouncilAgentVersions(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listPromptCouncilAgentVersions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPromptCouncilAgentVersionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPromptCouncilAgentVersions>>
>;
export type ListPromptCouncilAgentVersionsQueryError = ErrorType<void>;

/**
 * @summary List prior versions of an agent's system prompt
 */

export function useListPromptCouncilAgentVersions<
  TData = Awaited<ReturnType<typeof listPromptCouncilAgentVersions>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPromptCouncilAgentVersions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPromptCouncilAgentVersionsQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Snapshots the agent's current `(system_prompt, model)` into
the versions table (so the restore itself is reversible) and
then writes the prior version's values back onto the agent
row.

 * @summary Restore an agent to a prior version
 */
export const getRestorePromptCouncilAgentVersionUrl = (
  id: string,
  versionId: string,
) => {
  return `/api/prompt-council/agents/${id}/versions/${versionId}/restore`;
};

export const restorePromptCouncilAgentVersion = async (
  id: string,
  versionId: string,
  options?: RequestInit,
): Promise<PromptCouncilAgent> => {
  return customFetch<PromptCouncilAgent>(
    getRestorePromptCouncilAgentVersionUrl(id, versionId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getRestorePromptCouncilAgentVersionMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restorePromptCouncilAgentVersion>>,
    TError,
    { id: string; versionId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restorePromptCouncilAgentVersion>>,
  TError,
  { id: string; versionId: string },
  TContext
> => {
  const mutationKey = ["restorePromptCouncilAgentVersion"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restorePromptCouncilAgentVersion>>,
    { id: string; versionId: string }
  > = (props) => {
    const { id, versionId } = props ?? {};

    return restorePromptCouncilAgentVersion(id, versionId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RestorePromptCouncilAgentVersionMutationResult = NonNullable<
  Awaited<ReturnType<typeof restorePromptCouncilAgentVersion>>
>;

export type RestorePromptCouncilAgentVersionMutationError = ErrorType<void>;

/**
 * @summary Restore an agent to a prior version
 */
export const useRestorePromptCouncilAgentVersion = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restorePromptCouncilAgentVersion>>,
    TError,
    { id: string; versionId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof restorePromptCouncilAgentVersion>>,
  TError,
  { id: string; versionId: string },
  TContext
> => {
  return useMutation(
    getRestorePromptCouncilAgentVersionMutationOptions(options),
  );
};

/**
 * Returns all rebuttals the operator has configured. On first
call, lazily seeds the seven shipped defaults
(`too_expensive`, `have_a_guy`, `happy_with_site`, `not_dm`,
`send_info`, `call_back`, `not_interested`) — but only if the
operator has zero rows. Once a default is deleted it stays
deleted.

 * @summary List the operator's objection rebuttals
 */
export const getListObjectionRebuttalsUrl = () => {
  return `/api/objection-rebuttals`;
};

export const listObjectionRebuttals = async (
  options?: RequestInit,
): Promise<ObjectionRebuttalList> => {
  return customFetch<ObjectionRebuttalList>(getListObjectionRebuttalsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListObjectionRebuttalsQueryKey = () => {
  return [`/api/objection-rebuttals`] as const;
};

export const getListObjectionRebuttalsQueryOptions = <
  TData = Awaited<ReturnType<typeof listObjectionRebuttals>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listObjectionRebuttals>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListObjectionRebuttalsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listObjectionRebuttals>>
  > = ({ signal }) => listObjectionRebuttals({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listObjectionRebuttals>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListObjectionRebuttalsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listObjectionRebuttals>>
>;
export type ListObjectionRebuttalsQueryError = ErrorType<unknown>;

/**
 * @summary List the operator's objection rebuttals
 */

export function useListObjectionRebuttals<
  TData = Awaited<ReturnType<typeof listObjectionRebuttals>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listObjectionRebuttals>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListObjectionRebuttalsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a custom objection rebuttal
 */
export const getCreateObjectionRebuttalUrl = () => {
  return `/api/objection-rebuttals`;
};

export const createObjectionRebuttal = async (
  createObjectionRebuttalBody: CreateObjectionRebuttalBody,
  options?: RequestInit,
): Promise<ObjectionRebuttal> => {
  return customFetch<ObjectionRebuttal>(getCreateObjectionRebuttalUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createObjectionRebuttalBody),
  });
};

export const getCreateObjectionRebuttalMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createObjectionRebuttal>>,
    TError,
    { data: BodyType<CreateObjectionRebuttalBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createObjectionRebuttal>>,
  TError,
  { data: BodyType<CreateObjectionRebuttalBody> },
  TContext
> => {
  const mutationKey = ["createObjectionRebuttal"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createObjectionRebuttal>>,
    { data: BodyType<CreateObjectionRebuttalBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createObjectionRebuttal(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateObjectionRebuttalMutationResult = NonNullable<
  Awaited<ReturnType<typeof createObjectionRebuttal>>
>;
export type CreateObjectionRebuttalMutationBody =
  BodyType<CreateObjectionRebuttalBody>;
export type CreateObjectionRebuttalMutationError = ErrorType<void>;

/**
 * @summary Create a custom objection rebuttal
 */
export const useCreateObjectionRebuttal = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createObjectionRebuttal>>,
    TError,
    { data: BodyType<CreateObjectionRebuttalBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createObjectionRebuttal>>,
  TError,
  { data: BodyType<CreateObjectionRebuttalBody> },
  TContext
> => {
  return useMutation(getCreateObjectionRebuttalMutationOptions(options));
};

/**
 * @summary Update a rebuttal's label, trigger text, or response
 */
export const getUpdateObjectionRebuttalUrl = (id: string) => {
  return `/api/objection-rebuttals/${id}`;
};

export const updateObjectionRebuttal = async (
  id: string,
  updateObjectionRebuttalBody: UpdateObjectionRebuttalBody,
  options?: RequestInit,
): Promise<ObjectionRebuttal> => {
  return customFetch<ObjectionRebuttal>(getUpdateObjectionRebuttalUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateObjectionRebuttalBody),
  });
};

export const getUpdateObjectionRebuttalMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateObjectionRebuttal>>,
    TError,
    { id: string; data: BodyType<UpdateObjectionRebuttalBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateObjectionRebuttal>>,
  TError,
  { id: string; data: BodyType<UpdateObjectionRebuttalBody> },
  TContext
> => {
  const mutationKey = ["updateObjectionRebuttal"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateObjectionRebuttal>>,
    { id: string; data: BodyType<UpdateObjectionRebuttalBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateObjectionRebuttal(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateObjectionRebuttalMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateObjectionRebuttal>>
>;
export type UpdateObjectionRebuttalMutationBody =
  BodyType<UpdateObjectionRebuttalBody>;
export type UpdateObjectionRebuttalMutationError = ErrorType<void>;

/**
 * @summary Update a rebuttal's label, trigger text, or response
 */
export const useUpdateObjectionRebuttal = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateObjectionRebuttal>>,
    TError,
    { id: string; data: BodyType<UpdateObjectionRebuttalBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateObjectionRebuttal>>,
  TError,
  { id: string; data: BodyType<UpdateObjectionRebuttalBody> },
  TContext
> => {
  return useMutation(getUpdateObjectionRebuttalMutationOptions(options));
};

/**
 * @summary Delete a rebuttal
 */
export const getDeleteObjectionRebuttalUrl = (id: string) => {
  return `/api/objection-rebuttals/${id}`;
};

export const deleteObjectionRebuttal = async (
  id: string,
  options?: RequestInit,
): Promise<DeleteObjectionRebuttal200> => {
  return customFetch<DeleteObjectionRebuttal200>(
    getDeleteObjectionRebuttalUrl(id),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteObjectionRebuttalMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteObjectionRebuttal>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteObjectionRebuttal>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteObjectionRebuttal"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteObjectionRebuttal>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteObjectionRebuttal(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteObjectionRebuttalMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteObjectionRebuttal>>
>;

export type DeleteObjectionRebuttalMutationError = ErrorType<void>;

/**
 * @summary Delete a rebuttal
 */
export const useDeleteObjectionRebuttal = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteObjectionRebuttal>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteObjectionRebuttal>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteObjectionRebuttalMutationOptions(options));
};

/**
 * Contract only for task #311 — the analyzer/estimation engine is
implemented in a later task. Accepts a raw project description plus
optional intake hints and returns a draft estimate (with detected
features, clarifying questions, assumptions, build-vs-buy, risk
flags, blocks, and a scoring snapshot). The estimate is the
primary, terminal artifact; approval/handoff are opt-in.

 * @summary Analyze a pasted project description into a draft estimate
 */
export const getAnalyzeCockpitProjectUrl = () => {
  return `/api/cockpit/analyze`;
};

export const analyzeCockpitProject = async (
  cockpitAnalyzeBody: CockpitAnalyzeBody,
  options?: RequestInit,
): Promise<CockpitEstimateDetail> => {
  return customFetch<CockpitEstimateDetail>(getAnalyzeCockpitProjectUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(cockpitAnalyzeBody),
  });
};

export const getAnalyzeCockpitProjectMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof analyzeCockpitProject>>,
    TError,
    { data: BodyType<CockpitAnalyzeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof analyzeCockpitProject>>,
  TError,
  { data: BodyType<CockpitAnalyzeBody> },
  TContext
> => {
  const mutationKey = ["analyzeCockpitProject"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof analyzeCockpitProject>>,
    { data: BodyType<CockpitAnalyzeBody> }
  > = (props) => {
    const { data } = props ?? {};

    return analyzeCockpitProject(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AnalyzeCockpitProjectMutationResult = NonNullable<
  Awaited<ReturnType<typeof analyzeCockpitProject>>
>;
export type AnalyzeCockpitProjectMutationBody = BodyType<CockpitAnalyzeBody>;
export type AnalyzeCockpitProjectMutationError = ErrorType<unknown>;

/**
 * @summary Analyze a pasted project description into a draft estimate
 */
export const useAnalyzeCockpitProject = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof analyzeCockpitProject>>,
    TError,
    { data: BodyType<CockpitAnalyzeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof analyzeCockpitProject>>,
  TError,
  { data: BodyType<CockpitAnalyzeBody> },
  TContext
> => {
  return useMutation(getAnalyzeCockpitProjectMutationOptions(options));
};

/**
 * @summary List the operator's estimates, newest-first
 */
export const getListCockpitEstimatesUrl = (
  params?: ListCockpitEstimatesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/cockpit/estimates?${stringifiedParams}`
    : `/api/cockpit/estimates`;
};

export const listCockpitEstimates = async (
  params?: ListCockpitEstimatesParams,
  options?: RequestInit,
): Promise<CockpitEstimate[]> => {
  return customFetch<CockpitEstimate[]>(getListCockpitEstimatesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListCockpitEstimatesQueryKey = (
  params?: ListCockpitEstimatesParams,
) => {
  return [`/api/cockpit/estimates`, ...(params ? [params] : [])] as const;
};

export const getListCockpitEstimatesQueryOptions = <
  TData = Awaited<ReturnType<typeof listCockpitEstimates>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCockpitEstimatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCockpitEstimates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListCockpitEstimatesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCockpitEstimates>>
  > = ({ signal }) =>
    listCockpitEstimates(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCockpitEstimates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCockpitEstimatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCockpitEstimates>>
>;
export type ListCockpitEstimatesQueryError = ErrorType<unknown>;

/**
 * @summary List the operator's estimates, newest-first
 */

export function useListCockpitEstimates<
  TData = Awaited<ReturnType<typeof listCockpitEstimates>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCockpitEstimatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCockpitEstimates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCockpitEstimatesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create an estimate from intake fields (no analysis)
 */
export const getCreateCockpitEstimateUrl = () => {
  return `/api/cockpit/estimates`;
};

export const createCockpitEstimate = async (
  cockpitAnalyzeBody: CockpitAnalyzeBody,
  options?: RequestInit,
): Promise<CockpitEstimateDetail> => {
  return customFetch<CockpitEstimateDetail>(getCreateCockpitEstimateUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(cockpitAnalyzeBody),
  });
};

export const getCreateCockpitEstimateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCockpitEstimate>>,
    TError,
    { data: BodyType<CockpitAnalyzeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCockpitEstimate>>,
  TError,
  { data: BodyType<CockpitAnalyzeBody> },
  TContext
> => {
  const mutationKey = ["createCockpitEstimate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCockpitEstimate>>,
    { data: BodyType<CockpitAnalyzeBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createCockpitEstimate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCockpitEstimateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCockpitEstimate>>
>;
export type CreateCockpitEstimateMutationBody = BodyType<CockpitAnalyzeBody>;
export type CreateCockpitEstimateMutationError = ErrorType<unknown>;

/**
 * @summary Create an estimate from intake fields (no analysis)
 */
export const useCreateCockpitEstimate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCockpitEstimate>>,
    TError,
    { data: BodyType<CockpitAnalyzeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCockpitEstimate>>,
  TError,
  { data: BodyType<CockpitAnalyzeBody> },
  TContext
> => {
  return useMutation(getCreateCockpitEstimateMutationOptions(options));
};

/**
 * @summary Get one estimate with its blocks and phases
 */
export const getGetCockpitEstimateUrl = (id: string) => {
  return `/api/cockpit/estimates/${id}`;
};

export const getCockpitEstimate = async (
  id: string,
  options?: RequestInit,
): Promise<CockpitEstimateDetail> => {
  return customFetch<CockpitEstimateDetail>(getGetCockpitEstimateUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetCockpitEstimateQueryKey = (id: string) => {
  return [`/api/cockpit/estimates/${id}`] as const;
};

export const getGetCockpitEstimateQueryOptions = <
  TData = Awaited<ReturnType<typeof getCockpitEstimate>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCockpitEstimate>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCockpitEstimateQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCockpitEstimate>>
  > = ({ signal }) => getCockpitEstimate(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCockpitEstimate>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCockpitEstimateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCockpitEstimate>>
>;
export type GetCockpitEstimateQueryError = ErrorType<void>;

/**
 * @summary Get one estimate with its blocks and phases
 */

export function useGetCockpitEstimate<
  TData = Awaited<ReturnType<typeof getCockpitEstimate>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCockpitEstimate>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCockpitEstimateQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update intake/scope fields on an estimate
 */
export const getUpdateCockpitEstimateUrl = (id: string) => {
  return `/api/cockpit/estimates/${id}`;
};

export const updateCockpitEstimate = async (
  id: string,
  updateCockpitEstimateBody: UpdateCockpitEstimateBody,
  options?: RequestInit,
): Promise<CockpitEstimateDetail> => {
  return customFetch<CockpitEstimateDetail>(getUpdateCockpitEstimateUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateCockpitEstimateBody),
  });
};

export const getUpdateCockpitEstimateMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCockpitEstimate>>,
    TError,
    { id: string; data: BodyType<UpdateCockpitEstimateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCockpitEstimate>>,
  TError,
  { id: string; data: BodyType<UpdateCockpitEstimateBody> },
  TContext
> => {
  const mutationKey = ["updateCockpitEstimate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCockpitEstimate>>,
    { id: string; data: BodyType<UpdateCockpitEstimateBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateCockpitEstimate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCockpitEstimateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCockpitEstimate>>
>;
export type UpdateCockpitEstimateMutationBody =
  BodyType<UpdateCockpitEstimateBody>;
export type UpdateCockpitEstimateMutationError = ErrorType<void>;

/**
 * @summary Update intake/scope fields on an estimate
 */
export const useUpdateCockpitEstimate = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCockpitEstimate>>,
    TError,
    { id: string; data: BodyType<UpdateCockpitEstimateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCockpitEstimate>>,
  TError,
  { id: string; data: BodyType<UpdateCockpitEstimateBody> },
  TContext
> => {
  return useMutation(getUpdateCockpitEstimateMutationOptions(options));
};

/**
 * @summary Delete an estimate and its blocks/phases
 */
export const getDeleteCockpitEstimateUrl = (id: string) => {
  return `/api/cockpit/estimates/${id}`;
};

export const deleteCockpitEstimate = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteCockpitEstimateUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteCockpitEstimateMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCockpitEstimate>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCockpitEstimate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteCockpitEstimate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCockpitEstimate>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteCockpitEstimate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCockpitEstimateMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCockpitEstimate>>
>;

export type DeleteCockpitEstimateMutationError = ErrorType<void>;

/**
 * @summary Delete an estimate and its blocks/phases
 */
export const useDeleteCockpitEstimate = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCockpitEstimate>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteCockpitEstimate>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteCockpitEstimateMutationOptions(options));
};

/**
 * @summary Add a build block to an estimate
 */
export const getAddCockpitBlockUrl = (id: string) => {
  return `/api/cockpit/estimates/${id}/blocks`;
};

export const addCockpitBlock = async (
  id: string,
  cockpitBlockBody: CockpitBlockBody,
  options?: RequestInit,
): Promise<CockpitBlock> => {
  return customFetch<CockpitBlock>(getAddCockpitBlockUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(cockpitBlockBody),
  });
};

export const getAddCockpitBlockMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addCockpitBlock>>,
    TError,
    { id: string; data: BodyType<CockpitBlockBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addCockpitBlock>>,
  TError,
  { id: string; data: BodyType<CockpitBlockBody> },
  TContext
> => {
  const mutationKey = ["addCockpitBlock"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addCockpitBlock>>,
    { id: string; data: BodyType<CockpitBlockBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return addCockpitBlock(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddCockpitBlockMutationResult = NonNullable<
  Awaited<ReturnType<typeof addCockpitBlock>>
>;
export type AddCockpitBlockMutationBody = BodyType<CockpitBlockBody>;
export type AddCockpitBlockMutationError = ErrorType<void>;

/**
 * @summary Add a build block to an estimate
 */
export const useAddCockpitBlock = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addCockpitBlock>>,
    TError,
    { id: string; data: BodyType<CockpitBlockBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof addCockpitBlock>>,
  TError,
  { id: string; data: BodyType<CockpitBlockBody> },
  TContext
> => {
  return useMutation(getAddCockpitBlockMutationOptions(options));
};

/**
 * @summary Update a build block
 */
export const getUpdateCockpitBlockUrl = (id: string, blockId: string) => {
  return `/api/cockpit/estimates/${id}/blocks/${blockId}`;
};

export const updateCockpitBlock = async (
  id: string,
  blockId: string,
  cockpitBlockBody: CockpitBlockBody,
  options?: RequestInit,
): Promise<CockpitBlock> => {
  return customFetch<CockpitBlock>(getUpdateCockpitBlockUrl(id, blockId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(cockpitBlockBody),
  });
};

export const getUpdateCockpitBlockMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCockpitBlock>>,
    TError,
    { id: string; blockId: string; data: BodyType<CockpitBlockBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCockpitBlock>>,
  TError,
  { id: string; blockId: string; data: BodyType<CockpitBlockBody> },
  TContext
> => {
  const mutationKey = ["updateCockpitBlock"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCockpitBlock>>,
    { id: string; blockId: string; data: BodyType<CockpitBlockBody> }
  > = (props) => {
    const { id, blockId, data } = props ?? {};

    return updateCockpitBlock(id, blockId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCockpitBlockMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCockpitBlock>>
>;
export type UpdateCockpitBlockMutationBody = BodyType<CockpitBlockBody>;
export type UpdateCockpitBlockMutationError = ErrorType<void>;

/**
 * @summary Update a build block
 */
export const useUpdateCockpitBlock = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCockpitBlock>>,
    TError,
    { id: string; blockId: string; data: BodyType<CockpitBlockBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCockpitBlock>>,
  TError,
  { id: string; blockId: string; data: BodyType<CockpitBlockBody> },
  TContext
> => {
  return useMutation(getUpdateCockpitBlockMutationOptions(options));
};

/**
 * @summary Remove a build block
 */
export const getDeleteCockpitBlockUrl = (id: string, blockId: string) => {
  return `/api/cockpit/estimates/${id}/blocks/${blockId}`;
};

export const deleteCockpitBlock = async (
  id: string,
  blockId: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteCockpitBlockUrl(id, blockId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteCockpitBlockMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCockpitBlock>>,
    TError,
    { id: string; blockId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCockpitBlock>>,
  TError,
  { id: string; blockId: string },
  TContext
> => {
  const mutationKey = ["deleteCockpitBlock"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCockpitBlock>>,
    { id: string; blockId: string }
  > = (props) => {
    const { id, blockId } = props ?? {};

    return deleteCockpitBlock(id, blockId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCockpitBlockMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCockpitBlock>>
>;

export type DeleteCockpitBlockMutationError = ErrorType<void>;

/**
 * @summary Remove a build block
 */
export const useDeleteCockpitBlock = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCockpitBlock>>,
    TError,
    { id: string; blockId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteCockpitBlock>>,
  TError,
  { id: string; blockId: string },
  TContext
> => {
  return useMutation(getDeleteCockpitBlockMutationOptions(options));
};

/**
 * @summary Duplicate a build block within its estimate
 */
export const getDuplicateCockpitBlockUrl = (id: string, blockId: string) => {
  return `/api/cockpit/estimates/${id}/blocks/${blockId}/duplicate`;
};

export const duplicateCockpitBlock = async (
  id: string,
  blockId: string,
  options?: RequestInit,
): Promise<CockpitBlock> => {
  return customFetch<CockpitBlock>(getDuplicateCockpitBlockUrl(id, blockId), {
    ...options,
    method: "POST",
  });
};

export const getDuplicateCockpitBlockMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof duplicateCockpitBlock>>,
    TError,
    { id: string; blockId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof duplicateCockpitBlock>>,
  TError,
  { id: string; blockId: string },
  TContext
> => {
  const mutationKey = ["duplicateCockpitBlock"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof duplicateCockpitBlock>>,
    { id: string; blockId: string }
  > = (props) => {
    const { id, blockId } = props ?? {};

    return duplicateCockpitBlock(id, blockId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DuplicateCockpitBlockMutationResult = NonNullable<
  Awaited<ReturnType<typeof duplicateCockpitBlock>>
>;

export type DuplicateCockpitBlockMutationError = ErrorType<void>;

/**
 * @summary Duplicate a build block within its estimate
 */
export const useDuplicateCockpitBlock = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof duplicateCockpitBlock>>,
    TError,
    { id: string; blockId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof duplicateCockpitBlock>>,
  TError,
  { id: string; blockId: string },
  TContext
> => {
  return useMutation(getDuplicateCockpitBlockMutationOptions(options));
};

/**
 * Contract only for task #311 — summary generation is implemented in
a later task. Returns the estimate with `summary_text` populated.

 * @summary Generate the internal summary text for an estimate
 */
export const getGenerateCockpitSummaryUrl = (id: string) => {
  return `/api/cockpit/estimates/${id}/summary`;
};

export const generateCockpitSummary = async (
  id: string,
  options?: RequestInit,
): Promise<CockpitEstimateDetail> => {
  return customFetch<CockpitEstimateDetail>(getGenerateCockpitSummaryUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getGenerateCockpitSummaryMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateCockpitSummary>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateCockpitSummary>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["generateCockpitSummary"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateCockpitSummary>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return generateCockpitSummary(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateCockpitSummaryMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateCockpitSummary>>
>;

export type GenerateCockpitSummaryMutationError = ErrorType<void>;

/**
 * @summary Generate the internal summary text for an estimate
 */
export const useGenerateCockpitSummary = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateCockpitSummary>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateCockpitSummary>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getGenerateCockpitSummaryMutationOptions(options));
};

/**
 * @summary List past estimates similar to this one (for learning)
 */
export const getListSimilarCockpitEstimatesUrl = (
  id: string,
  params?: ListSimilarCockpitEstimatesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/cockpit/estimates/${id}/similar?${stringifiedParams}`
    : `/api/cockpit/estimates/${id}/similar`;
};

export const listSimilarCockpitEstimates = async (
  id: string,
  params?: ListSimilarCockpitEstimatesParams,
  options?: RequestInit,
): Promise<CockpitEstimate[]> => {
  return customFetch<CockpitEstimate[]>(
    getListSimilarCockpitEstimatesUrl(id, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListSimilarCockpitEstimatesQueryKey = (
  id: string,
  params?: ListSimilarCockpitEstimatesParams,
) => {
  return [
    `/api/cockpit/estimates/${id}/similar`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListSimilarCockpitEstimatesQueryOptions = <
  TData = Awaited<ReturnType<typeof listSimilarCockpitEstimates>>,
  TError = ErrorType<void>,
>(
  id: string,
  params?: ListSimilarCockpitEstimatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSimilarCockpitEstimates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListSimilarCockpitEstimatesQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSimilarCockpitEstimates>>
  > = ({ signal }) =>
    listSimilarCockpitEstimates(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listSimilarCockpitEstimates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSimilarCockpitEstimatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSimilarCockpitEstimates>>
>;
export type ListSimilarCockpitEstimatesQueryError = ErrorType<void>;

/**
 * @summary List past estimates similar to this one (for learning)
 */

export function useListSimilarCockpitEstimates<
  TData = Awaited<ReturnType<typeof listSimilarCockpitEstimates>>,
  TError = ErrorType<void>,
>(
  id: string,
  params?: ListSimilarCockpitEstimatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSimilarCockpitEstimates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSimilarCockpitEstimatesQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Marks the estimate approved and captures an immutable handoff
snapshot of the approved scope. Approval is optional — an estimate
is a complete artifact without it.

 * @summary Approve an estimate's scope (opt-in, pre-handoff)
 */
export const getApproveCockpitEstimateUrl = (id: string) => {
  return `/api/cockpit/estimates/${id}/approve`;
};

export const approveCockpitEstimate = async (
  id: string,
  approveCockpitEstimateBody?: ApproveCockpitEstimateBody,
  options?: RequestInit,
): Promise<CockpitEstimateDetail> => {
  return customFetch<CockpitEstimateDetail>(getApproveCockpitEstimateUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(approveCockpitEstimateBody),
  });
};

export const getApproveCockpitEstimateMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveCockpitEstimate>>,
    TError,
    { id: string; data: BodyType<ApproveCockpitEstimateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approveCockpitEstimate>>,
  TError,
  { id: string; data: BodyType<ApproveCockpitEstimateBody> },
  TContext
> => {
  const mutationKey = ["approveCockpitEstimate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approveCockpitEstimate>>,
    { id: string; data: BodyType<ApproveCockpitEstimateBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return approveCockpitEstimate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApproveCockpitEstimateMutationResult = NonNullable<
  Awaited<ReturnType<typeof approveCockpitEstimate>>
>;
export type ApproveCockpitEstimateMutationBody =
  BodyType<ApproveCockpitEstimateBody>;
export type ApproveCockpitEstimateMutationError = ErrorType<void>;

/**
 * @summary Approve an estimate's scope (opt-in, pre-handoff)
 */
export const useApproveCockpitEstimate = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveCockpitEstimate>>,
    TError,
    { id: string; data: BodyType<ApproveCockpitEstimateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof approveCockpitEstimate>>,
  TError,
  { id: string; data: BodyType<ApproveCockpitEstimateBody> },
  TContext
> => {
  return useMutation(getApproveCockpitEstimateMutationOptions(options));
};

/**
 * Returns the handoff snapshot Prompt HQ consumes. 409 if the
estimate has not been approved yet.

 * @summary Get the immutable approved-scope handoff snapshot
 */
export const getGetCockpitHandoffUrl = (id: string) => {
  return `/api/cockpit/estimates/${id}/handoff`;
};

export const getCockpitHandoff = async (
  id: string,
  options?: RequestInit,
): Promise<CockpitHandoff> => {
  return customFetch<CockpitHandoff>(getGetCockpitHandoffUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetCockpitHandoffQueryKey = (id: string) => {
  return [`/api/cockpit/estimates/${id}/handoff`] as const;
};

export const getGetCockpitHandoffQueryOptions = <
  TData = Awaited<ReturnType<typeof getCockpitHandoff>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCockpitHandoff>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCockpitHandoffQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCockpitHandoff>>
  > = ({ signal }) => getCockpitHandoff(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCockpitHandoff>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCockpitHandoffQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCockpitHandoff>>
>;
export type GetCockpitHandoffQueryError = ErrorType<void>;

/**
 * @summary Get the immutable approved-scope handoff snapshot
 */

export function useGetCockpitHandoff<
  TData = Awaited<ReturnType<typeof getCockpitHandoff>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCockpitHandoff>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCockpitHandoffQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List the operator's block catalog (seeded on first use)
 */
export const getListCockpitCatalogBlocksUrl = () => {
  return `/api/cockpit/catalog/blocks`;
};

export const listCockpitCatalogBlocks = async (
  options?: RequestInit,
): Promise<CockpitCatalogBlock[]> => {
  return customFetch<CockpitCatalogBlock[]>(getListCockpitCatalogBlocksUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListCockpitCatalogBlocksQueryKey = () => {
  return [`/api/cockpit/catalog/blocks`] as const;
};

export const getListCockpitCatalogBlocksQueryOptions = <
  TData = Awaited<ReturnType<typeof listCockpitCatalogBlocks>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCockpitCatalogBlocks>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListCockpitCatalogBlocksQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCockpitCatalogBlocks>>
  > = ({ signal }) => listCockpitCatalogBlocks({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCockpitCatalogBlocks>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCockpitCatalogBlocksQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCockpitCatalogBlocks>>
>;
export type ListCockpitCatalogBlocksQueryError = ErrorType<unknown>;

/**
 * @summary List the operator's block catalog (seeded on first use)
 */

export function useListCockpitCatalogBlocks<
  TData = Awaited<ReturnType<typeof listCockpitCatalogBlocks>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCockpitCatalogBlocks>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCockpitCatalogBlocksQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List the operator's tool/plugin catalog (seeded on first use)
 */
export const getListCockpitCatalogToolsUrl = () => {
  return `/api/cockpit/catalog/tools`;
};

export const listCockpitCatalogTools = async (
  options?: RequestInit,
): Promise<CockpitCatalogTool[]> => {
  return customFetch<CockpitCatalogTool[]>(getListCockpitCatalogToolsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListCockpitCatalogToolsQueryKey = () => {
  return [`/api/cockpit/catalog/tools`] as const;
};

export const getListCockpitCatalogToolsQueryOptions = <
  TData = Awaited<ReturnType<typeof listCockpitCatalogTools>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCockpitCatalogTools>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListCockpitCatalogToolsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCockpitCatalogTools>>
  > = ({ signal }) => listCockpitCatalogTools({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCockpitCatalogTools>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCockpitCatalogToolsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCockpitCatalogTools>>
>;
export type ListCockpitCatalogToolsQueryError = ErrorType<unknown>;

/**
 * @summary List the operator's tool/plugin catalog (seeded on first use)
 */

export function useListCockpitCatalogTools<
  TData = Awaited<ReturnType<typeof listCockpitCatalogTools>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCockpitCatalogTools>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCockpitCatalogToolsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List the operator's preloaded sample projects (seeded on first use)
 */
export const getListCockpitSampleProjectsUrl = () => {
  return `/api/cockpit/catalog/samples`;
};

export const listCockpitSampleProjects = async (
  options?: RequestInit,
): Promise<CockpitSampleProject[]> => {
  return customFetch<CockpitSampleProject[]>(
    getListCockpitSampleProjectsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListCockpitSampleProjectsQueryKey = () => {
  return [`/api/cockpit/catalog/samples`] as const;
};

export const getListCockpitSampleProjectsQueryOptions = <
  TData = Awaited<ReturnType<typeof listCockpitSampleProjects>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCockpitSampleProjects>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListCockpitSampleProjectsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCockpitSampleProjects>>
  > = ({ signal }) => listCockpitSampleProjects({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCockpitSampleProjects>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCockpitSampleProjectsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCockpitSampleProjects>>
>;
export type ListCockpitSampleProjectsQueryError = ErrorType<unknown>;

/**
 * @summary List the operator's preloaded sample projects (seeded on first use)
 */

export function useListCockpitSampleProjects<
  TData = Awaited<ReturnType<typeof listCockpitSampleProjects>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCockpitSampleProjects>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCockpitSampleProjectsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}
